<template>
  <component
    :is="page ? 'q-page': 'div'"
    style="touch-action: none;"
    data-test-id="cart-component"
    :class="{
      'col': order.isRemote || order.hasOrderItems,
      'col-auto': !order.isRemote && !order.hasOrderItems,
      'column': $q.screen.lt.sm || isDrawer || $register,
      'text-responsive': $q.screen.lt.sm || isDrawer,
      'q-px-sm': $q.screen.lt.sm && !isDrawer,
    }"
  >
    <div
      class="smooth-scroll scroll col"
      style="max-width: 100%; border-bottom: 1px solid rgba(0, 0, 0, 0.2);"
      :style="{
        'border-bottom': isDrawer ? '1px solid rgba(0, 0, 0, 0.2)' : undefined,
        position: isCartPageInLandscapeView ? 'relative' : undefined,
        overflow: isCartPageInLandscapeView ? 'visible' : undefined
      }"
    >
      <q-list
        :bordered="!isDrawer"
        separator
        class="bg-responsive"
        :class="{ 'q-mb-md': isCartPageInLandscapeView }"
        :style="{
          position: isCartPageInLandscapeView ? 'absolute' : undefined,
          width: isCartPageInLandscapeView ? '100%' : undefined
        }"
      >
        <redemptions
          v-if="!hideRedemptions && (!$register || (isDrawer && showRedemptionsOnRegister))"
          :view-only="viewOnly"
          @register="register"
          @login="login"
          @apply-voucher="applyVoucher"
          @apply-discount="applyDiscount"
        />
        <q-banner
          v-if="order.orderItemsWithoutEmptyDonations && order.orderItemsWithoutEmptyDonations.length < 1 && !($register && $q.screen.gt.xs) "
          rounded
          class="q-ma-sm text-center"
          style="background: rgba(0, 0, 0, 0.05);"
        >
          <div class="text-body1 text-weight-bolder text-grey">
            {{ $t('cart.yourCartIsEmpty') }}
          </div>
        </q-banner>

        <template v-if="!hideOrder">
          <component
            :is="$register || $q.screen.xs ? 'div' : 'q-expansion-item'"
            v-if="cartFormattedOrderItems.membershipIntervals.length"
            v-model="expandDefault"
            :header-class="$register ? '' : 'bg-responsive-grey-3 q-px-sm'"
            expand-separator
            :dense="$q.screen.xs"
          >
            <template
              v-if="!$register && $q.screen.gt.xs"
              #header
            >
              <q-item-section
                avatar
                style="max-width: 44px; min-width: 44px;"
              >
                <q-avatar
                  icon="fal fa-id-card"
                  text-color="responsive"
                />
              </q-item-section>

              <q-item-section
                :class="$q.screen.gt.xs ? 'text-h6' : 'text-weight-bolder text-body1'"
                style="font-size: 16px;"
              >
                {{ $tc('membership.membership', 1) }}
              </q-item-section>
            </template>
            <q-list
              separator
            >
              <q-item
                v-if="$register"
                class="q-px-sm"
                dense
              >
                <q-item-section
                  class="text-uppercase text-grey-7 text-bold"
                >
                  {{ $tc('membership.membership', 1) }}
                </q-item-section>
              </q-item>
              <q-slide-item
                v-for="membershipIntervalItem in cartFormattedOrderItems.membershipIntervals"
                :key="membershipIntervalItem.id"
                :ref="'cartItem' + membershipIntervalItem.id"
                right-color="negative"
                class="bg-responsive"
                @right="handleDeleteMembership(membershipIntervalItem, resetSlide)"
                @click="!viewOnly && membershipIntervalItem.draft && $emit('modify-membership')"
              >
                <template
                  v-if="!viewOnly || !membershipIntervalItem.voided"
                  #right
                >
                  <q-icon
                    v-if="!viewOnly || membershipIntervalItem.draft"
                    left
                    name="delete"
                    @click.stop="resetSlide => handleDeleteMembership(membershipIntervalItem, resetSlide)"
                  />
                  {{ $t('actions.delete') }}
                </template>
                <q-item
                  class="q-px-sm"
                  :class="`state-${membershipIntervalItem.state}`"
                >
                  <q-item-section class="col justify-evenly">
                    <q-item-label
                      v-if="$register"
                      overline
                      class="text-uppercase"
                    >
                      {{ membershipIntervalItem.description }}
                    </q-item-label>
                    <template
                      v-for="(detail, index) in membershipIntervalItem.details"
                    >
                      <q-item-label
                        v-if="detail.description"
                        :key="detail.key"
                      >
                        <template v-if="index !== 0">
                          -
                        </template>{{ detail.description }}
                      </q-item-label>
                    </template>
                    <q-item-label
                      v-if="!!membershipIntervalItem.membershipInterval.endDate"
                      class="text-grey"
                    >
                      {{ membershipIntervalItem.membershipInterval.startDate.i18n('date') }} to
                      {{ membershipIntervalItem.membershipInterval.endDate.i18n('date') }}
                    </q-item-label>
                    <q-item-label
                      v-else
                      class="text-grey"
                    >
                      {{ membershipIntervalItem.membershipInterval.startDate.i18n('date') }} onwards
                    </q-item-label>
                    <q-item-label v-if="!$register">
                      <price
                        :item="membershipIntervalItem"
                        color="responsive"
                      />
                    </q-item-label>
                  </q-item-section>
                  <q-item-section
                    v-if="$register"
                    class="col-auto"
                  >
                    <price
                      :item="membershipIntervalItem"
                    />
                  </q-item-section>
                  <q-item-section
                    v-else
                    top
                    side
                    class="col-auto row justify-between"
                  >
                    <q-item-label class="d-flex">
                      <q-btn
                        v-if="!viewOnly"
                        icon="fal fa-trash-can"
                        class="col-auto q-px-xs"
                        color="responsive-grey-2"
                        text-color="responsive"
                        round
                        :dense="isDrawer"
                        :size="isDrawer && $consumer ? 'sm': undefined"
                        @click.stop="resetSlide => handleDeleteMembership(membershipIntervalItem, resetSlide)"
                      >
                        <q-tooltip>Click or swipe to remove this membership</q-tooltip>
                      </q-btn>

                      <q-chip
                        class="bg-transparent"
                        text-color="responsive"
                        flat
                        square
                      >
                        1
                      </q-chip>
                    </q-item-label>
                  </q-item-section>
                </q-item>
              </q-slide-item>
            </q-list>
          </component>
          <component
            :is="$register || $q.screen.xs ? 'div' : 'q-expansion-item'"
            v-if="order.ticketOrderItems.length > 0 || cartFormattedOrderItems.dayPass"
            v-model="expandTickets"
            :header-class="$register ? '' : 'bg-responsive-grey-3 q-px-sm'"
            :dense="$q.screen.lt.sm"
            data-test-id="cart-tickets-container"
          >
            <!-- Section header -->
            <template
              v-if="!$register && $q.screen.gt.xs"
              #header
            >
              <q-item-section
                avatar
                style="max-width: 44px; min-width: 44px;"
              >
                <q-avatar
                  icon="fal fa-ticket"
                  text-color="responsive"
                />
              </q-item-section>

              <q-item-section
                :class="$q.screen.gt.xs ? 'text-h6' : 'text-weight-bolder text-body1'"
                style="font-size: 16px;"
              >
                {{ $tc('ticket.ticket', 2) }}
              </q-item-section>
              <q-item-section side>
                <div
                  class="row items-center"
                >
                  {{ $_.toLower($tc('ticket.ticketCount', order.ticketOrderItems.length)) }}
                  &nbsp;&middot;&nbsp;
                  <i18n-n
                    :value="order.ticketOrderItemsTotal"
                    format="currency"
                    scope="global"
                  />
                </div>
              </q-item-section>
            </template>
            <!-- Day pass header (POS) -->
            <q-item
              v-if="cartFormattedOrderItems.dayPass && $register"
              class="q-px-sm"
              style="border-bottom: solid 1px rgba(220, 220, 220, 0.5);"
              dense
            >
              <q-item-section
                class="text-uppercase text-responsive-grey-7 text-bold"
              >
                {{ $t('ticket.dayPass') }}
              </q-item-section>
            </q-item>
            <!-- Day pass options -->
            <q-slide-item
              v-if="cartFormattedOrderItems.dayPass"
              :ref="'cartItem' + cartFormattedOrderItems.id"
              right-color="negative"
              class="bg-responsive"
              :style="{ 'border-bottom': $register ? undefined : '1px solid rgba(0, 0, 0, 0.1)' }"
              @right="handleDeleteDayPass"
            >
              <template
                v-if="!viewOnly"
                #right
              >
                <q-icon
                  v-if="cartFormattedOrderItems.dayPass.draft"
                  left
                  name="delete"
                />
                {{ $t('actions.delete') }}
              </template>
              <q-item
                class="q-px-sm"
                :class="`state-${cartFormattedOrderItems.dayPass.state}`"
              >
                <q-item-section class="col justify-evenly">
                  <q-item-label
                    :overline="$register"
                    :class="$register ? 'text-uppercase' : undefined"
                  >
                    {{ $t('ticket.dayPassPurchase') }}
                  </q-item-label>
                  <q-item-label v-if="!$register">
                    <i18n-n
                      class="text-bold"
                      tag="span"
                      :value="cartFormattedOrderItems.dayPass.price"
                      format="currency"
                      scope="global"
                    />
                  </q-item-label>
                </q-item-section>
                <q-item-section
                  v-if="$register"
                  class="col-auto text-right text-bold text-responsive"
                >
                  <i18n-n
                    :value="cartFormattedOrderItems.dayPass.price"
                    format="currency"
                    scope="global"
                  />
                </q-item-section>
                <q-item-section
                  v-if="!viewOnly"
                  class="col-auto row"
                >
                  <q-item-label class="d-flex">
                    <q-btn
                      v-if="$consumer || $kiosk"
                      class="col-auto"
                      icon="fal fa-trash-can"
                      color="responsive-grey-2"
                      text-color="responsive"
                      round
                      :dense="isDrawer"
                      :size="isDrawer && $consumer ? 'sm': 'md'"
                      @click.stop="handleDeleteDayPass"
                    >
                      <q-tooltip>Click or swipe to remove this day pass</q-tooltip>
                    </q-btn>
                    <q-chip
                      class="bg-transparent"
                      text-color="responsive"
                      flat
                      square
                    >
                      1
                    </q-chip>
                  </q-item-label>
                </q-item-section>
              </q-item>
            </q-slide-item>
            <!-- Ticket list container -->
            <q-list
              separator
            >
              <!-- Ticket section header (POS) -->
              <q-item
                v-if="cartFormattedOrderItems.tickets.length && $register"
                class="q-px-sm"
                style="border-top: solid 1px #DFDFDF;"
                dense
              >
                <q-item-section
                  class="col text-uppercase text-grey-7 text-bold row"
                >
                  <div class="row text-grey-7 text-bold">
                    {{ $tc('ticket.ticket', 2) }}
                  </div>
                </q-item-section>
                <q-item-section
                  v-if="showGroupTicketPrinting"
                  class="col text-right"
                >
                  <div>
                    <q-toggle
                      v-model="order.groupTicket"
                      :label="$tc('ticket.groupTicket', 1)"
                      icon="group"
                      left-label
                    />
                  </div>
                </q-item-section>
              </q-item>

              <q-expansion-item
                v-for="tickets in cartFormattedOrderItems.tickets"
                :key="tickets.showing.id"
                :model-value="true"
                :header-class="$register ? 'expansion-header q-px-sm' : 'expansion-header q-px-sm no-border'"
                :default-opened="$q.screen.gt.xs"
                expand-separator
                data-test-id="cart-tickets-expansion-item"
              >
                <template #header>
                  <q-item-section
                    top
                    class="col column text-center q-mt-xs items-center"

                    :style="{ 'max-width': isDrawer || $register || $q.screen.lt.sm ? '50px' : '80px' }"
                  >
                    <q-img
                      :src="tickets.showing.movie.posterImageSmallUrl"
                    />
                  </q-item-section>

                  <q-item-section
                    class="col justify-start text-responsive"
                  >
                    <q-item-label
                      v-if="$register"
                      overline
                      class="text-uppercase"
                    >
                      {{ $tc('showing.showing', 1) }}
                    </q-item-label>
                    <q-item-label>
                      {{ tickets.showing.movie.name }}
                    </q-item-label>
                    <q-item-label>
                      {{ tickets.showing.formattedTime(true, true) }}
                    </q-item-label>
                    <q-item-label class="row q-gutter-x-sm">
                      <transition
                        v-if="$register"
                        leave-class="hidden"
                        enter-active-class="animated bounceIn"
                      >
                        <q-chip
                          v-if="tickets.count > 1"
                          :key="tickets.count"
                          style="font-size: 14px"
                          class="q-py-xs"
                          square
                          color="primary"
                          :text-color="$isColorDark(currentSite.primaryColor) ? 'white' : 'black'"
                        >
                          x {{ tickets.count }}
                        </q-chip>
                      </transition>
                      <q-chip
                        v-if="order.purchasingDayPass"
                        square
                        :dense="$q.screen.lt.lg"
                        class="col-auto"
                        :class="$q.screen.lt.md ? 'no-padding' : 'q-py-xs'"
                      >
                        <i18n-n
                          class="inline-block"
                          tag="span"
                          :value="order.dayPassTicketPricePerPerson"
                          format="currency"
                          scope="global"
                        /> / person
                      </q-chip>
                    </q-item-label>
                  </q-item-section>
                  <q-item-section class="col-auto text-right">
                    <i18n-n
                      v-if="$register"
                      class="text-bold text-responsive"
                      tag="span"
                      :value="tickets.displayTotal"
                      format="currency"
                      scope="global"
                    />
                  </q-item-section>
                </template>
                <q-list
                  :separator="!isDrawer"
                >
                  <member-tickets-item
                    v-for="orderItem in tickets.memberTickets"
                    :ref="'cartItem' + orderItem.id"
                    :key="orderItem.id"
                    :order-item="orderItem"
                    :is-drawer="isDrawer"
                    :view-only="viewOnly"
                    @delete="handleDeleteRequest"
                    @edit="edit"
                  />
                  <guest-tickets-item
                    v-for="guestTickets in tickets.guestTickets"
                    :ref="'cartItem' + guestTickets.lastOrderItem.id"
                    :key="guestTickets.firstOrderItem.id"
                    :guest-tickets="guestTickets"
                    :is-drawer="isDrawer"
                    :view-only="viewOnly"
                    @touch-hold="handleTicketTouchHold"
                    @remove-guest-ticket="(orderItem) => checkoutData.removeSeats.push(orderItem)"
                    @add-guest-ticket="(showing, ticketType, itemPackage) => !touchHoldId && addGuestTicket(showing, ticketType, itemPackage)"
                    @delete="handleDeleteRequest"
                    @edit="edit"
                  />
                </q-list>
              </q-expansion-item>
              <booking-fees
                v-if="showBookingFees"
                :booking-fees="cartFormattedOrderItems.bookingFees"
                class="q-ma-sm bg-responsive-grey-1 text-body2"
              />
            </q-list>
          </component>

          <component
            :is="$register || $q.screen.xs ? 'div' : 'q-expansion-item'"
            v-if="cartFormattedOrderItems.activityTickets.length > 0 || cartFormattedOrderItems.dayPass"
            v-model="expandTickets"
            :header-class="$register ? '' : 'bg-responsive-grey-3 q-px-sm'"
            expand-separator
            :dense="$q.screen.lt.sm"
          >
            <template
              v-if="!$register && $q.screen.gt.xs"
              #header
            >
              <q-item-section
                avatar
                style="max-width: 44px; min-width: 44px;"
              >
                <q-avatar
                  icon="fal fa-ticket"
                  text-color="responsive"
                />
              </q-item-section>

              <q-item-section
                :class="$q.screen.gt.xs ? 'text-h6' : 'text-weight-bolder text-body1'"
                style="font-size: 16px;"
              >
                {{ $tc('ticket.activityTicket', 2) }}
              </q-item-section>
              <q-item-section side>
                <div
                  class="row items-center"
                >
                  {{ numberOfActivityTicketsAndDayPass }}
                  {{ $tc('ticket.ticket', numberOfActivityTicketsAndDayPass > 1) }}
                  &nbsp;&middot;&nbsp;
                  <i18n-n
                    :value="activityTicketsAndDayPassTotal"
                    format="currency"
                    scope="global"
                  />
                </div>
              </q-item-section>
            </template>
            <q-item
              v-if="cartFormattedOrderItems.dayPass && $register"
              class="q-px-sm"
              style="border-bottom: solid 1px #DFDFDF;"
              dense
            >
              <q-item-section
                class="text-uppercase text-grey-7 text-bold"
              >
                Day Pass
              </q-item-section>
            </q-item>
            <q-slide-item
              v-if="cartFormattedOrderItems.dayPass"
              :ref="'cartItem' + cartFormattedOrderItems.id"
              right-color="negative"
              class="bg-responsive"
              :style="{ 'border-bottom': $register ? undefined : '1px solid rgba(0, 0, 0, 0.1)' }"
              @right="handleDeleteDayPass"
            >
              <template
                v-if="!viewOnly"
                #right
              >
                <q-icon
                  v-if="cartFormattedOrderItems.dayPass.draft"
                  left
                  name="delete"
                />
                Delete
              </template>
              <q-item
                class="q-px-sm"
                :class="`state-${cartFormattedOrderItems.dayPass.state}`"
              >
                <q-item-section class="col justify-evenly">
                  <q-item-label
                    :overline="$register"
                    :class="$register ? 'text-uppercase' : undefined"
                  >
                    Day Pass Purchase
                  </q-item-label>
                  <q-item-label v-if="!$register">
                    <i18n-n
                      class="text-bold"
                      tag="span"
                      :value="cartFormattedOrderItems.dayPass.price"
                      format="currency"
                      scope="global"
                    />
                  </q-item-label>
                </q-item-section>
                <q-item-section
                  v-if="$register"
                  class="col-auto text-right text-bold text-dark"
                >
                  <i18n-n
                    :value="cartFormattedOrderItems.dayPass.price"
                    format="currency"
                    scope="global"
                  />
                </q-item-section>
                <q-item-section
                  v-if="!viewOnly"
                  class="col-auto row"
                >
                  <q-item-label class="d-flex">
                    <q-btn
                      v-if="$consumer || $kiosk"
                      class="col-auto"
                      icon="fal fa-trash-can"
                      color="responsive-grey-2"
                      text-color="responsive"
                      round
                      :dense="isDrawer"
                      :size="isDrawer && $consumer ? 'sm': undefined"
                      @click.stop="handleDeleteDayPass"
                    >
                      <q-tooltip>Click or swipe to remove this day pass</q-tooltip>
                    </q-btn>
                    <q-chip
                      class="bg-transparent"
                      text-color="responsive"
                      flat
                      square
                    >
                      1
                    </q-chip>
                  </q-item-label>
                </q-item-section>
              </q-item>
            </q-slide-item>
            <q-list
              separator
            >
              <q-item
                v-if="cartFormattedOrderItems.activityTickets.length && $register"
                class="q-px-sm"
                style="border-top: solid 1px #DFDFDF;"
                dense
              >
                <q-item-section
                  class="col text-uppercase text-grey-7 text-bold row"
                >
                  <div class="row text-grey-7 text-bold">
                    Activity Tickets
                  </div>
                </q-item-section>
                <q-item-section
                  v-if="showGroupTicketPrinting"
                  class="col text-right"
                >
                  <div>
                    <q-toggle
                      v-model="order.groupTicket"
                      label="Group Ticket"
                      icon="group"
                      left-label
                    />
                  </div>
                </q-item-section>
              </q-item>

              <q-expansion-item
                v-for="activityTickets in cartFormattedOrderItems.activityTickets"
                :key="activityTickets.activitySession.id"
                :model-value="true"
                :header-class="$register ? 'expansion-header q-px-sm' : 'expansion-header q-px-sm no-border'"
                :default-opened="$q.screen.gt.xs"
                expand-separator
              >
                <template #header>
                  <q-item-section
                    top
                    class="col column text-center q-mt-xs items-center"

                    :style="{ 'max-width': isDrawer || $register || $q.screen.lt.sm ? '50px' : '80px' }"
                  >
                    <q-img
                      :src="activityTickets.activitySession.activity.posterImageSmallUrl"
                    />
                  </q-item-section>

                  <q-item-section
                    class="col justify-start"
                  >
                    <q-item-label
                      v-if="$register"
                      overline
                      class="text-uppercase"
                    >
                      Activity
                    </q-item-label>
                    <q-item-label>
                      {{ activityTickets.activitySession.activity.name }}
                    </q-item-label>
                    <q-item-label v-if="activityTickets.orderItems[0].activityTicket.activityUnitQuantityDescription">
                      {{ activityTickets.orderItems[0].activityTicket.activityUnitQuantityDescription }}
                    </q-item-label>
                    <q-item-label>
                      {{ activityTickets.orderItems[0].activityTicket.formattedTime(true, true) }}
                    </q-item-label>
                    <q-item-label class="row q-gutter-x-sm">
                      <transition
                        v-if="$register"
                        leave-class="hidden"
                        enter-active-class="animated bounceIn"
                      >
                        <q-chip
                          v-if="activityTickets.count > 1"
                          :key="activityTickets.count"
                          style="font-size: 14px"
                          class="q-py-xs"
                          square
                          color="primary"
                          text-color="white"
                        >
                          x {{ activityTickets.count }}
                        </q-chip>
                      </transition>
                      <q-chip
                        v-if="order.purchasingDayPass"
                        square
                        :dense="$q.screen.lt.lg"
                        class="col-auto"
                        :class="$q.screen.lt.md ? 'no-padding' : 'q-py-xs'"
                      >
                        <i18n-n
                          class="inline-block"
                          tag="span"
                          :value="order.dayPassTicketPricePerPerson"
                          format="currency"
                          scope="global"
                        /> / person
                      </q-chip>
                    </q-item-label>
                  </q-item-section>
                  <q-item-section class="col-auto text-right">
                    <i18n-n
                      v-if="$register"
                      class="text-bold text-dark"
                      tag="span"
                      :value="activityTickets.displayTotal"
                      format="currency"
                      scope="global"
                    />
                  </q-item-section>
                </template>
                <q-list
                  :separator="!isDrawer"
                >
                  <member-tickets-item
                    v-for="orderItem in activityTickets.memberTickets"
                    :ref="'cartItem' + orderItem.id"
                    :key="orderItem.id"
                    :order-item="orderItem"
                    :is-drawer="isDrawer"
                    :view-only="viewOnly"
                    @delete="handleDeleteRequest"
                    @edit="edit"
                  />
                  <guest-tickets-item
                    v-for="guestTickets in activityTickets.guestTickets"
                    :ref="'cartItem' + guestTickets.lastOrderItem.id"
                    :key="guestTickets.firstOrderItem.id"
                    :guest-tickets="guestTickets"
                    :is-drawer="isDrawer"
                    :view-only="viewOnly"
                    @touch-hold="handleTicketTouchHold"
                    @add-guest-ticket="(showing, ticketType, itemPackage) => !touchHoldId && addGuestTicket(showing, ticketType, itemPackage)"
                    @delete="handleDeleteRequest"
                    @edit="edit"
                  />
                </q-list>
              </q-expansion-item>
            </q-list>
          </component>

          <component
            :is="$register || $q.screen.xs ? 'div' : 'q-expansion-item'"
            v-if="(order.openTab && !order.hasOrderItems) || cartFormattedOrderItems.items.length"
            v-model="expandConcessions"
            :header-class="$register ? '' : 'bg-responsive-grey-3 q-px-sm'"
            expand-separator
            :dense="$q.screen.xs"
          >
            <template
              v-if="!$register && $q.screen.gt.xs"
              #header
            >
              <q-item-section
                avatar
                style="max-width: 44px; min-width: 44px;"
              >
                <q-avatar
                  icon="fal fa-popcorn"
                  text-color="responsive"
                />
              </q-item-section>

              <q-item-section
                :class="$q.screen.gt.xs ? 'text-h6' : 'text-weight-bolder text-body1'"
                style="font-size: 16px;"
              >
                {{ $t('common.food') }}
              </q-item-section>
              <q-item-section side>
                <div
                  class="row items-center"
                >
                  {{ order.itemsOrderItems.length }}
                  {{ order.itemsOrderItems.length > 1 ? 'items' : 'item' }}
                  &nbsp;&middot;&nbsp;
                  <i18n-n
                    :value="order.itemOrderItemsTotal"
                    format="currency"
                    scope="global"
                  />
                </div>
              </q-item-section>
            </template>

            <transition
              v-if="$q.screen.lt.sm"
              leave-active-class="animated fadeOutUp"
              enter-active-class="animated fadeInDown"
            >
              <q-banner
                v-if="deliveryMessage"
                dense
                class="bg-warning q-ma-sm"
                rounded
              >
                <div
                  class="text-center col-auto self-center"
                  :class="$getTextColor(currentSite, 'warning')"
                >
                  {{ $t('checkout.delivery.deliveryTo') }} <b>{{ deliveryMessage }}</b>
                </div>
              </q-banner>
            </transition>
            <q-list
              separator
            >
              <q-item
                v-if="((order.openTab && !order.hasOrderItems) || cartFormattedOrderItems.items.length) && $register"
                class="q-px-sm row"
                dense
                :style="{ 'border-top': $register ? '1px solid rgba(0,0,0,0.12)' : undefined }"
              >
                <q-item-section>
                  <div
                    class="row justify-between items-end"
                    @click="!viewOnly && triggerShowOrderOptions()"
                  >
                    <div class="text-uppercase text-responsive-grey-7 text-bold">
                      {{ $tc('item.item', 2) }}
                    </div>
                    <div
                      v-if="!isDrawer"
                      class="row q-gutter-xs items-start"
                    >
                      <q-chip
                        v-if="order.name"
                        dense
                        size="sm"
                        square
                      >
                        {{ $_.startCase(order.name) }}
                      </q-chip>
                      <q-chip
                        v-if="order.hasDueTime"
                        icon="access_time"
                        dense
                        size="sm"
                        square
                        :label="order.formattedDueTime"
                      />
                      <q-chip
                        v-if="order.remoteOrder && !order.hasDueTime"
                        dense
                        size="sm"
                        square
                      >
                        Remote
                      </q-chip>
                      <q-chip
                        v-if="order.deliveryTypeOptions.length"
                        dense
                        size="sm"
                        square
                      >
                        {{ $_.startCase(order.deliveryTypeName) }}
                      </q-chip>
                      <q-chip
                        v-if="order.deliveryLocation"
                        dense
                        size="sm"
                        square
                      >
                        {{ $_.startCase(order.deliveryLocation) }}
                      </q-chip>
                      <q-chip
                        v-if="order.deliveryPositions.length"
                        dense
                        size="sm"
                        square
                      >
                        {{ order.deliveryPositions.join(', ') }}
                      </q-chip>
                      <q-btn
                        v-if="!viewOnly"
                        label="Options"
                        size="xs"
                        outline
                        dense
                        style="margin-top: 3px;"
                        class="q-px-xs"
                      />
                    </div>
                  </div>
                </q-item-section>
              </q-item>

              <items-item
                v-for="items in cartFormattedOrderItems.items"
                :key="items.firstOrderItem.id"
                :ref="'cartItem' + items.lastOrderItem.id"
                :items="items"
                :is-drawer="isDrawer"
                :view-only="viewOnly"
                @touch-hold="handleItemTouchHold"
                @delete="handleDeleteRequest"
                @edit="edit"
                @remove="removeOrderItem"
                @add="item => !touchHoldId && addOrderItem(item)"
                @remove-voucher="removeVoucher"
                @place-order="type => $emit('place-order', type)"
              />
              <q-item
                v-if="((order.openTab && !order.hasOrderItems) || cartFormattedOrderItems.items.length) && !hideDelivery && !$register"
                class="q-px-sm row"
              >
                <q-item-section>
                  <div
                    class="column q-px-sm"
                    @click="!viewOnly && triggerShowOrderOptions()"
                  >
                    <div class="row justify-start items-start q-gutter-x-sm">
                      <span
                        v-if="order.remoteOrder && !order.hasDueTime && $register"
                        class="text-subtitle2"
                      >
                        Remote
                      </span>
                      <span
                        v-if="order.deliveryTypeOptions.length"
                        class="text-subtitle2"
                      >
                        {{ $_.startCase(order.deliveryTypeName) }}
                      </span>
                      <span
                        v-if="order.deliveryLocation"
                        class="text-subtitle2"
                      >
                        {{ $_.startCase(order.deliveryLocation) }}
                      </span>
                      <span
                        v-if="order.deliveryPositions"
                        class="text-subtitle2"
                      >
                        {{ order.deliveryPositions.join(', ') }}
                      </span>
                    </div>
                    <span
                      v-if="order.hasDueTime"
                      class="text-subtitle2 text-responsive-grey-6 block"
                    >
                      @ {{ order.formattedDueTime }}
                    </span>
                  </div>
                </q-item-section>
                <q-item-section
                  v-if="!viewOnly"
                  side
                >
                  <q-btn
                    class="q-px-sm"
                    :icon-right="$q.screen.lt.sm ? 'navigate_next' : undefined"
                    :label="$t('actions.change')"
                    color="responsive-white"
                    text-color="primary"
                    rounded
                    dense
                    @click="!viewOnly && triggerShowOrderOptions()"
                  />
                </q-item-section>
              </q-item>
            </q-list>
          </component>

          <component
            :is="$register || $q.screen.xs ? 'div' : 'q-expansion-item'"
            v-if="cartFormattedOrderItems.vouchers.length"
            v-model="expandDefault"
            :header-class="$register ? '' : 'bg-responsive-grey-3 q-px-sm'"
            :style="{ 'border-top': $register ? '1px solid rgba(0, 0, 0, 0.1)' : undefined }"
            :dense="$q.screen.xs"
            expand-separator
          >
            <template
              v-if="!$register && $q.screen.gt.xs"
              #header
            >
              <q-item-section
                avatar
                style="max-width: 44px; min-width: 44px;"
              >
                <q-avatar
                  icon="fal fa-badge-percent"
                  text-color="responsive"
                />
              </q-item-section>

              <q-item-section
                :class="$q.screen.gt.xs ? 'text-h6' : 'text-weight-bolder text-body1'"
                style="font-size: 16px;"
              >
                {{ $tc('voucher.voucher', 2) }}
              </q-item-section>
              <q-item-section side>
                <div
                  class="row items-center"
                >
                  {{ order.vouchersOrderItems.length }}
                  {{ order.vouchersOrderItems.length > 1 ? 'items' : 'item' }}

                  &nbsp;&middot;&nbsp;
                  <i18n-n
                    :value="order.voucherOrderItemsTotal"
                    format="currency"
                    scope="global"
                  />
                </div>
              </q-item-section>
            </template>

            <q-list
              separator
            >
              <q-item
                v-if="$register"
                class="q-px-sm"
                dense
              >
                <q-item-section
                  class="text-uppercase text-grey-7 text-bold"
                >
                  {{ $tc('voucher.voucher', 2) }}
                </q-item-section>
              </q-item>
              <q-slide-item
                v-for="vouchers in cartFormattedOrderItems.vouchers"
                :key="vouchers.firstOrderItem.id"
                :ref="'cartItem' + vouchers.lastOrderItem.id"
                class="bg-responsive"
                :right-color="removeIcon(vouchers.orderItems).color"
                @right="resetSlide => handleDeleteVouchers(vouchers.orderItems, resetSlide)"
                @click="!viewOnly && vouchers.firstOrderItem.draft && edit(vouchers.lastOrderItem)"
              >
                <template
                  v-if="!viewOnly"
                  #right
                >
                  <q-icon
                    v-if="vouchers.firstOrderItem.draft"
                    left
                    name="delete"
                  />
                  {{ $t('actions.deleteAll') }}
                </template>
                <q-item
                  class="row q-px-sm"
                  :class="`state-${vouchers.firstOrderItem.state}`"
                >
                  <q-item-section class="col column justify-evenly q-gutter-y-xs">
                    <q-item-label
                      v-if="$register"
                      class="text-uppercase"
                      overline
                    >
                      {{ vouchers.firstOrderItem.price ? 'Voucher Purchase' : 'Service Issue' }}
                    </q-item-label>
                    <q-item-label>
                      {{ vouchers.firstOrderItem.title }}
                    </q-item-label>
                    <div class="row items-center q-gutter-x-xs">
                      <q-item-label
                        v-if="findDetail(vouchers.firstOrderItem.details, 'recipient_email')"
                        class="text-responsive-grey-6"
                      >
                        <q-btn
                          v-if="$register"
                          class="align-left q-px-xs"
                          :color="vouchers.firstOrderItem.group && vouchers.count > 1 ? 'negative' : 'positive'"
                          size="sm"
                          dense
                          outline
                          @click="!viewOnly && ((vouchers.firstOrderItem.group && vouchers.count > 1) || updateOrderItemEmail(vouchers.firstOrderItem, false))"
                        >
                          {{ findDetail(vouchers.firstOrderItem.details, 'recipient_email').recipient_email }}
                        </q-btn>
                        <template v-else>
                          <span class="text-responsive">To:</span>
                          {{ findDetail(vouchers.firstOrderItem.details, 'recipient_email').recipient_email }}
                          <q-btn
                            dense
                            :color="vouchers.firstOrderItem.group && vouchers.count > 1 ? 'negative' : 'dark'"
                            class="align-left text-lowercase"
                            icon="fal fa-pen"
                            size="sm"
                            rounded
                            flat
                            @click="!viewOnly && ((vouchers.firstOrderItem.group && vouchers.count > 1) || updateOrderItemEmail(vouchers.firstOrderItem, false))"
                          />
                          <div>
                            <span class="text-responsive">Message:</span>
                            <template v-if="findDetail(vouchers.firstOrderItem.details, 'message')">
                              {{ findDetail(vouchers.firstOrderItem.details, 'message').message }}
                            </template>
                          </div>
                        </template>
                      </q-item-label>
                    </div>
                    <q-item-label
                      v-if="$register && vouchers.firstOrderItem.voucherPurchase.card"
                      class="text-positive"
                    >
                      Card assigned
                    </q-item-label>
                    <q-item-label
                      v-if="$register && vouchers.firstOrderItem.voucherPurchase.requiresCard && vouchers.firstOrderItem.voucherPurchase.skipCard"
                      class="text-negative"
                    >
                      Card assignment required
                    </q-item-label>
                    <q-item-label
                      v-if="vouchers.firstOrderItem.voucherPurchase.user"
                      class="text-positive"
                    >
                      Voucher assigned to user {{ vouchers.firstOrderItem.voucherPurchase.user.name }}
                    </q-item-label>
                    <q-item-label
                      v-if="!vouchers.firstOrderItem.voucherPurchase.user && !vouchers.firstOrderItem.voucherPurchase.card"
                      class="text-negative"
                    >
                      No {{ !$register || vouchers.firstOrderItem.voucherPurchase.skipCard ? '' : 'card or' }} user assigned
                    </q-item-label>
                    <q-item-label v-if="!$register">
                      <price
                        :item="vouchers"
                        color="responsive"
                      />
                    </q-item-label>
                  </q-item-section>
                  <q-item-section
                    v-if="$register"
                    class="col-auto text-right text-bold"
                  >
                    <price
                      :item="vouchers.firstOrderItem"
                    />
                  </q-item-section>
                  <q-item-section
                    v-if="!viewOnly"
                    class="col-auto row"
                  >
                    <q-item-label
                      class="d-flex"
                    >
                      <q-btn
                        v-if="$consumer || $kiosk"
                        class="col-auto"
                        icon="fal fa-trash-can"
                        color="responsive-grey-2"
                        text-color="responsive"
                        round
                        :dense="isDrawer"
                        :size="isDrawer && $consumer ? 'sm': undefined"
                        @click.stop="resetSlide => handleDeleteVouchers(vouchers.orderItems, resetSlide)"
                      >
                        <q-tooltip>Click or swipe to remove this day pass</q-tooltip>
                      </q-btn>

                      <q-chip
                        class="bg-transparent"
                        text-color="responsive"
                        flat
                        square
                      >
                        {{ vouchers.count }}
                      </q-chip>
                    </q-item-label>
                  </q-item-section>
                </q-item>
              </q-slide-item>
            </q-list>
          </component>
          <!-- Gift cards container -->
          <component
            :is="$register || $q.screen.xs ? 'div' : 'q-expansion-item'"
            v-if="cartFormattedOrderItems.giftCards.length"
            v-model="expandDefault"
            :header-class="$register ? '' : 'bg-responsive-grey-3 q-px-sm'"
            expand-separator
            :dense="$q.screen.xs"
            :style="{ 'border-top': $register ? '1px solid rgba(0, 0, 0, 0.1)' : undefined }"
          >
            <!-- Gift cards section header (non-POS) -->
            <template
              v-if="!$register && $q.screen.gt.xs"
              #header
            >
              <q-item-section
                avatar
                style="max-width: 44px; min-width: 44px;"
              >
                <q-avatar
                  icon="fal fa-gift-card"
                  text-color="responsive"
                />
              </q-item-section>

              <q-item-section
                :class="$q.screen.gt.xs ? 'text-h6' : 'text-weight-bolder text-body1'"
                style="font-size: 16px;"
              >
                {{ $tc('giftCard.giftCard', 2) }}
              </q-item-section>
              <q-item-section side>
                <div
                  class="row items-center"
                >
                  {{ order.giftCardOrderItems.length }}
                  {{ order.giftCardOrderItems.length > 1 ? 'items' : 'item' }}

                  &nbsp;&middot;&nbsp;
                  <i18n-n
                    :value="order.giftCardOrderItemsTotal"
                    format="currency"
                    scope="global"
                  />
                </div>
              </q-item-section>
            </template>

            <q-list
              separator
            >
              <!-- Gift cards POS section header -->
              <q-item
                v-if="$register"
                class="q-px-sm"
                dense
              >
                <q-item-section
                  class="text-uppercase text-grey-7 text-bold"
                >
                  {{ $tc('giftCard.giftCard', 2) }}
                </q-item-section>
              </q-item>

              <!-- List of gift cards applied to the order -->
              <q-slide-item
                v-for="giftCards in cartFormattedOrderItems.giftCards"
                :key="giftCards.firstOrderItem.id"
                :ref="'cartItem' + giftCards.lastOrderItem.id"
                :right-color="removeIcon(giftCards.orderItems).color"
                class="bg-responsive"
                @right="resetSlide => handleDeleteRequest(giftCards.orderItems, resetSlide)"
                @click="!viewOnly && giftCards.firstOrderItem.draft && edit(giftCards.lastOrderItem)"
              >
                <template
                  v-if="!viewOnly"
                  #right
                >
                  <q-icon
                    v-if="giftCards.firstOrderItem.draft"
                    left
                    name="delete"
                  />
                  {{ $t('actions.deleteAll') }}
                </template>
                <q-item
                  class="row q-px-sm"
                  :class="`state-${giftCards.firstOrderItem.state}`"
                >
                  <q-item-section class="col column justify-evenly q-gutter-y-xs">
                    <q-item-label
                      :overline="$register"
                      :class="$register ? 'text-uppercase' : 'text-responsive'"
                    >
                      {{ findDetail(giftCards.firstOrderItem.details, 'name') ? findDetail(giftCards.firstOrderItem.details, 'name').name : 'Gift Card' }}
                      <template v-if="!$register">
                        -
                        <i18n-n
                          :value="giftCards.firstOrderItem.giftCard.initialValue"
                          format="currency"
                          scope="global"
                        />
                      </template>
                    </q-item-label>
                    <q-item-label v-if="$register">
                      <i18n-n
                        :value="giftCards.firstOrderItem.giftCard.initialValue"
                        format="currency"
                        scope="global"
                      />
                    </q-item-label>
                    <div
                      class="row items-center q-gutter-x-xs"
                    >
                      <q-item-label
                        v-if="findDetail(giftCards.firstOrderItem.details, 'recipient_email')"
                        class="text-responsive-grey-6"
                      >
                        <q-btn
                          v-if="$register"
                          dense
                          :color="giftCards.firstOrderItem.group && giftCards.count > 1 ? 'negative' : 'positive'"
                          class="align-left q-px-xs"
                          size="sm"
                          outline
                          @click="!viewOnly && ((giftCards.firstOrderItem.group && giftCards.count > 1) || updateOrderItemEmail(giftCards.firstOrderItem, true))"
                        >
                          {{ findDetail(giftCards.firstOrderItem.details, 'recipient_email').recipient_email }}
                        </q-btn>
                        <template v-else>
                          <span class="text-responsive">To:</span>
                          {{ findDetail(giftCards.firstOrderItem.details, 'recipient_email').recipient_email }}
                          <q-btn
                            dense
                            :color="giftCards.firstOrderItem.group && giftCards.count > 1 ? 'negative' : 'dark'"
                            class="align-left text-lowercase"
                            size="sm"
                            rounded
                            flat
                            icon="fal fa-pen"
                            @click="!viewOnly && ((giftCards.firstOrderItem.group && giftCards.count > 1) || updateOrderItemEmail(giftCards.firstOrderItem, true))"
                          />
                          <div>
                            <span class="text-responsive">Message:</span>
                            <template v-if="findDetail(giftCards.firstOrderItem.details, 'message')">
                              {{ findDetail(giftCards.firstOrderItem.details, 'message').message }}
                            </template>
                          </div>
                        </template>
                      </q-item-label>
                    </div>
                    <q-item-label
                      v-if="$register && !giftCards.firstOrderItem.giftCard.card && !giftCards.firstOrderItem.giftCard.skipCard"
                      class="text-negative"
                    >
                      No Card Assigned
                    </q-item-label>
                    <q-item-label
                      v-else-if="$register && giftCards.firstOrderItem.giftCard.requiresCard && giftCards.firstOrderItem.giftCard.skipCard"
                      class="text-negative"
                    >
                      Card Assignment Required
                    </q-item-label>
                    <q-item-label
                      v-else-if="$register && !giftCards.firstOrderItem.giftCard.skipCard"
                      class="text-positive"
                    >
                      Card Assigned
                    </q-item-label>
                    <q-item-label>
                      <q-chip
                        v-if="giftCards.firstOrderItem.discount"
                        square
                        dense
                        color="secondary"
                        text-color="white"
                        size="sm"
                        :label="giftCards.firstOrderItem.discount.displayName"
                        :removable="!viewOnly && giftCards.firstOrderItem.state !== 'paid'"
                        @remove="order.removeDiscount(giftCards.firstOrderItem)"
                      />
                    </q-item-label>
                    <q-item-label v-if="!$register">
                      <price
                        :item="giftCards"
                        color="responsive"
                      />
                    </q-item-label>
                  </q-item-section>
                  <q-item-section
                    v-if="$register"
                    class="col-auto text-right text-bold"
                  >
                    <price
                      :item="giftCards.firstOrderItem"
                    />
                  </q-item-section>

                  <q-item-section
                    v-if="!viewOnly"
                    class="col-auto row"
                  >
                    <q-item-label
                      class="d-flex"
                    >
                      <q-btn
                        v-if="($consumer || $kiosk)"
                        class="col-auto q-px-xs"
                        icon="fal fa-trash-can"
                        color="responsive-grey-2"
                        text-color="responsive"
                        round
                        :dense="!isDrawer"
                        :size="isDrawer && $consumer ? 'sm': undefined"
                        @click.stop="resetSlide => handleDeleteRequest(giftCards.orderItems, resetSlide)"
                      >
                        <q-tooltip>Click or swipe to remove this day pass</q-tooltip>
                      </q-btn>
                      <q-chip
                        class="bg-transparent"
                        text-color="responsive"
                        flat
                        square
                      >
                        {{ giftCards.count }}
                      </q-chip>
                    </q-item-label>
                  </q-item-section>
                </q-item>
              </q-slide-item>
            </q-list>
          </component>

          <q-item
            v-if="cartFormattedOrderItems.voucherPackages.length"
            class="q-px-sm"
            dense
            :style="{ 'border-top': $register ? '1px solid rgba(0, 0, 0, 0.1)' : undefined }"
          >
            <q-item-section
              class="text-uppercase text-responsive-grey-7 text-bold"
            >
              {{ $tc('voucherPackage.voucherPackage', 2) }}
            </q-item-section>
          </q-item>
          <q-slide-item
            v-for="orderItem in cartFormattedOrderItems.voucherPackages"
            :key="orderItem.id"
            :ref="'cartItem' + orderItem.id"
            right-color="negative"
            class="bg-responsive"
            @right="resetSlide => handleDeleteRequest([orderItem], resetSlide)"
          >
            <template
              v-if="!viewOnly"
              #right
            >
              <q-icon
                v-if="orderItem.draft"
                left
                name="delete"
              />
              {{ $t('actions.deleteAll') }}
            </template>
            <q-item
              v-if="orderItem.issuedVoucherPackage.issuedVoucherPackageVouchers && orderItem.issuedVoucherPackage.issuedVoucherPackageVouchers.length"
              class="q-px-sm"
              :class="`state-${orderItem.state}`"
              clickable
              @click="!viewOnly && edit(orderItem)"
            >
              <q-item-section class="col justify-evenly">
                <q-item-label
                  overline
                  class="text-uppercase"
                >
                  {{ $t('voucherPackage.purchase') }}
                </q-item-label>
                <q-item-label>
                  {{ orderItem.title }}
                </q-item-label>
                <q-item-label
                  v-if="findDetail(orderItem.details, 'recipient_email')"
                >
                  <q-btn
                    dense
                    color="positive"
                    class="align-left q-px-xs"
                    size="sm"
                    outline
                    @click="!viewOnly && updateOrderItemEmail(orderItem, false)"
                  >
                    {{ findDetail(orderItem.details, 'recipient_email').recipient_email }}
                  </q-btn>
                </q-item-label>
                <q-item-label
                  v-if="$register && !orderItem.issuedVoucherPackage.card && !orderItem.issuedVoucherPackage.skipCard && !orderItem.issuedVoucherPackage.user"
                  class="text-negative"
                >
                  No {{ !$register || orderItem.issuedVoucherPackage.skipCard ? '' : 'Card or' }} User Assigned
                </q-item-label>
                <q-item-label
                  v-else-if="$register && orderItem.issuedVoucherPackage.requiresCard && orderItem.issuedVoucherPackage.skipCard"
                  class="text-negative"
                >
                  Card Assignment Required
                </q-item-label>
                <q-item-label
                  v-else-if="orderItem.issuedVoucherPackage.user"
                  class="text-positive"
                >
                  Voucher Package Assigned to {{ orderItem.issuedVoucherPackage.user.name }}
                </q-item-label>
                <q-item-label
                  v-else-if="$register && !orderItem.issuedVoucherPackage.skipCard"
                  class="text-positive"
                >
                  Card Assigned
                </q-item-label>
              </q-item-section>
              <q-item-section class="col-auto text-right text-bold">
                <i18n-n
                  :value="orderItem.price"
                  format="currency"
                  scope="global"
                />
              </q-item-section>
              <q-item-section
                v-if="!viewOnly"
                class="col-auto"
              >
                <q-btn
                  v-if="$consumer"
                  icon="delete"
                  color="grey"
                  flat
                  round
                  dense
                  @click.stop="resetSlide => handleDeleteRequest([orderItem], resetSlide)"
                >
                  <q-tooltip>Click or swipe to remove this voucher package</q-tooltip>
                </q-btn>
              </q-item-section>
            </q-item>
            <div v-else>
              <q-expansion-item
                :model-value="true"
                header-class="expansion-header q-px-sm"
                @click.stop="!$register && !viewOnly && edit(orderItem)"
              >
                <template #header>
                  <q-item-section class="col justify-evenly">
                    <q-item-label
                      overline
                      class="text-uppercase"
                    >
                      {{ $t('voucherPackage.purchase') }}
                    </q-item-label>
                    <q-item-label>
                      {{ orderItem.title }}
                    </q-item-label>
                    <q-item-label
                      v-if="findDetail(orderItem.details, 'recipient_email')"
                    >
                      <q-btn
                        dense
                        color="positive"
                        class="align-left q-px-xs"
                        size="sm"
                        outline
                        @click="!viewOnly && updateOrderItemEmail(orderItem, false)"
                      >
                        {{ findDetail(orderItem.details, 'recipient_email').recipient_email }}
                      </q-btn>
                    </q-item-label>
                  </q-item-section>
                  <q-item-section class="col-auto text-right text-bold">
                    <i18n-n
                      :value="orderItem.price"
                      format="currency"
                      scope="global"
                    />
                  </q-item-section>
                  <q-item-section
                    v-if="!viewOnly"
                    class="col-auto"
                  >
                    <q-btn
                      v-if="$consumer"
                      icon="delete"
                      color="grey"
                      flat
                      round
                      dense
                      @click.stop="resetSlide => handleDeleteRequest([orderItem], resetSlide)"
                    >
                      <q-tooltip>Click or swipe to remove this voucher package</q-tooltip>
                    </q-btn>
                  </q-item-section>
                </template>
                <q-list
                  separator
                >
                  <q-item
                    v-for="issuedVoucherPackage in orderItem.issuedVoucherPackage.issuedVoucherPackages.data"
                    :key="issuedVoucherPackage.id"
                    clickable
                    @click.stop="$register && !viewOnly && associateCardWithItem(issuedVoucherPackage, orderItem, issuedVoucherPackage.voucherType.name)"
                  >
                    <q-item
                      class="q-px-sm"
                      :style="orderItem.state !== 'draft' ? 'cursor: default;' : ''"
                    >
                      <q-item-section class="col justify-evenly">
                        <q-item-label>
                          <span v-if="issuedVoucherPackage.issuedVoucherPackageVouchers.data.length > 1">{{ issuedVoucherPackage.issuedVoucherPackageVouchers.data.length }}x </span>{{ issuedVoucherPackage.voucherType.name }}
                        </q-item-label>
                        <q-item-label
                          v-if="$register && !findDetail(orderItem.details, 'recipient_email') && !issuedVoucherPackage.card && !issuedVoucherPackage.skipCard"
                          class="text-negative"
                        >
                          No Card Assigned
                        </q-item-label>
                        <q-item-label
                          v-else-if="$register && !findDetail(orderItem.details, 'recipient_email') && issuedVoucherPackage.requiresCard && issuedVoucherPackage.skipCard"
                          class="text-negative"
                        >
                          Card Assignment Required
                        </q-item-label>
                        <q-item-label
                          v-else-if="$register && !findDetail(orderItem.details, 'recipient_email') && !issuedVoucherPackage.skipCard"
                          class="text-positive"
                        >
                          Card Assigned
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-item>
                </q-list>
              </q-expansion-item>
            </div>
          </q-slide-item>
          <component
            :is="$register || $q.screen.xs ? 'div' : 'q-expansion-item'"
            v-if="cartFormattedOrderItems.miscItems.length"
            v-model="expandDefault"
            :header-class="$register ? '' : 'bg-responsive-grey-3 q-px-sm'"
            expand-separator
            :dense="$q.screen.xs"
            :style="{ 'border-top': $register ? '1px solid rgba(0, 0, 0, 0.1)' : undefined }"
          >
            <template
              v-if="!$register && $q.screen.gt.xs"
              #header
            >
              <q-item-section
                avatar
                style="max-width: 44px; min-width: 44px;"
              >
                <q-avatar
                  icon="fal fa-box-heart"
                  text-color="responsive"
                />
              </q-item-section>

              <q-item-section
                :class="$q.screen.gt.xs ? 'text-h6' : 'text-weight-bolder text-body1'"
                style="font-size: 16px;"
              >
                {{ $t('common.misc') }}
              </q-item-section>
              <q-item-section side>
                <div
                  class="row items-center"
                >
                  {{ order.miscOrderItems.length }}
                  {{ order.miscOrderItems.length > 1 ? 'items' : 'item' }}

                  &nbsp;&middot;&nbsp;
                  <i18n-n
                    :value="order.miscOrderItemsTotal"
                    format="currency"
                    scope="global"
                  />
                </div>
              </q-item-section>
            </template>
            <q-list
              separator
            >
              <q-item
                v-if="$register"
                class="q-px-sm"
                dense
              >
                <q-item-section
                  class="text-uppercase text-grey-7 text-bold"
                >
                  {{ $t('common.misc') }}
                </q-item-section>
              </q-item>
              <q-slide-item
                v-for="orderItem in cartFormattedOrderItems.miscItems"
                :key="orderItem.id"
                :ref="'cartItem' + orderItem.id"
                right-color="negative"
                class="bg-responsive"
                @right="resetSlide => handleDeleteRequest([orderItem], resetSlide)"
                @click="!viewOnly && edit(orderItem)"
              >
                <template
                  v-if="!viewOnly"
                  #right
                >
                  <q-icon
                    v-if="orderItem.draft"
                    left
                    name="delete"
                  />
                  {{ $t('actions.deleteAll') }}
                </template>
                <q-item
                  :class="`state-${orderItem.state}`"
                  class="q-px-sm"
                >
                  <q-item-section class="col justify-evenly">
                    <q-item-label
                      :overline="$register"
                      :class="$register ? 'text-uppercase' : 'text-responsive'"
                    >
                      {{ $_.startCase(orderItem.type) }}
                    </q-item-label>
                    <q-item-label v-if="$register">
                      {{ orderItem.finalDescription }}
                    </q-item-label>
                    <q-item-label
                      v-if="!$register"
                      class="text-bold"
                    >
                      <i18n-n
                        :value="orderItem.displayPrice"
                        format="currency"
                        scope="global"
                      />
                    </q-item-label>
                  </q-item-section>

                  <q-item-section
                    v-if="$register"
                    class="col-auto text-right text-bold"
                  >
                    <i18n-n
                      :value="orderItem.displayPrice"
                      format="currency"
                      scope="global"
                    />
                  </q-item-section>
                  <q-item-section
                    v-if="!viewOnly"
                    class="col-auto"
                  >
                    <q-item-label
                      class="d-flex"
                    >
                      <q-btn
                        v-if="($consumer || $kiosk)"
                        class="col-auto q-px-xs"
                        icon="fal fa-trash-can"
                        color="responsive-grey-2"
                        text-color="responsive"
                        round
                        :dense="!isDrawer"
                        :size="isDrawer && $consumer ? 'sm': undefined"
                        @click.stop="resetSlide => handleDeleteRequest([orderItem], resetSlide)"
                      >
                        <q-tooltip>Click or swipe to remove this day pass</q-tooltip>
                      </q-btn>
                      <q-chip
                        class="bg-transparent"
                        text-color="responsive"
                        flat
                        square
                      >
                        1
                      </q-chip>
                    </q-item-label>
                  </q-item-section>
                </q-item>
              </q-slide-item>
            </q-list>
          </component>
        </template>
        <checkout-code-input
          v-if="(isDrawer && !hideVoucher)"
          :view-only="viewOnly"
          :is-drawer="isDrawer"
          @add-checkout-code="code => $emit('add-checkout-code', code)"
        />
      </q-list>
      <order-item-form
        v-if="!viewOnly"
        ref="form"
        @change="order.applyRedemptions()"
        @request-authorization="callback => $emit('request-authorization', callback)"
      />
      <order-options-dialog
        v-if="!viewOnly"
        v-model="showOrderOptions"
        :order="order"
        show-timing
        @find-user="$emit('find-user')"
        @merge-tab="value => $emit('merge-tab', value)"
        @update:model-value="value => showOrderOptions = value"
        @show-incoming-employee="showIncomingEmployeeSelectDialog"
      />
      <incoming-employee-select-dialog
        v-if="$register"
        ref="IncomingEmployeeSelectDialog"
        @incoming-employee-selected="requestIncomingEmployee"
      />
      <refund-dialog
        ref="refundDialog"
        @refund-success="$emit('refund-success')"
      />
      <unclaimed-refund-dialog
        v-if="$register"
        ref="unclaimedRefundDialog"
      />
    </div>
    <q-space
      v-if="$q.screen.gt.xs"
      :style="{ 'min-width': isCartPageInLandscapeView ? '15px' : undefined }"
    />
    <div
      v-if="!isDrawer && $q.screen.gt.xs"
      class="bg-responsive-white"
      :class="isCartPageInLandscapeView ? 'col-auto' : undefined"
      :style="{ 'width': isCartPageInLandscapeView ? '400px' : undefined }"
    >
      <q-list
        v-if="!order.draft && !order.openTab"
        bordered
        separator
        class="col-auto"
        :style="{ 'max-width': isCartPageInLandscapeView ? '400px' : undefined }"
      >
        <q-item
          class="q-px-sm justify-center"
          :class="$register ? undefined : 'column'"
          dense
        >
          <q-chip
            v-if="$register && order.unclaimedRefund"
            color="warning"
            text-color="white"
            size="lg"
            :label="order.unclaimedRefund"
            clickable
            @click="$refs.unclaimedRefundDialog.show(order)"
          />
          <q-chip
            :color="$register ? 'primary' : 'white'"
            :text-color="$register ? 'white' : 'black'"
            :size="$register ? 'lg' : 'md'"
            :label="'Order Id: ' + `#${order.id}`"
          />
          <q-chip
            v-if="order.lastTimePlaced"
            :color="$register ? 'secondary' : 'white'"
            :text-color="$register ? 'white' : 'black'"
            :size="$register ? 'lg' : 'md'"
            :label="`Placed ${order.lastTimePlaced}`"
          />
          <q-chip
            v-if="order.timeAwareShowingState === 'invalid-past'"
            label="Invalid, Past Order"
            :color="$register ? 'red' : 'white'"
            :text-color="$register ? 'white' : 'red'"
            :size="$register ? 'lg' : 'md'"
          />
          <q-chip
            v-if="order.timeAwareShowingState === 'invalid-future'"
            label="Invalid, Future Order"
            :color="$register ? 'red' : 'white'"
            :text-color="$register ? 'white' : 'red'"
            :size="$register ? 'lg' : 'md'"
          />
          <q-chip
            v-if="order.timeAwareShowingState === 'valid'"
            label="Order Valid"
            :color="$register ? 'positive' : 'white'"
            :text-color="$register ? 'white' : 'positive'"
            :size="$register ? 'lg' : 'md'"
          />
          <q-chip
            v-if="!order.hasCollectableTickets"
            label="Tickets Collected"
            :color="$register ? 'warning' : 'white'"
            :text-color="$register ? 'white' : 'positive'"
            :size="$register ? 'lg' : 'md'"
          />
        </q-item>
      </q-list>
      <q-list
        v-if="order.draft || order.openTab"
        :bordered="!isDrawer"
        separator
        class="col-auto"
      >
        <redemptions
          v-if="$register && showRedemptionsOnRegister"
          :view-only="viewOnly"
          @apply-voucher="applyVoucher"
          @apply-discount="applyDiscount"
        />
        <checkout-code-input
          v-if="$register"
          :view-only="viewOnly"
          :is-drawer="isDrawer"
          @input-checkout-code="isApplyingCode => $emit('input-checkout-code', isApplyingCode)"
        />
        <q-item
          v-if="order.exchangeFeeTotal > 0"
          class="q-px-sm"
          dense
        >
          <q-item-section
            class="col"
            :class="isDrawer ? 'text-uppercase text-grey-7 text-bold' : 'q-pl-sm'"
          >
            {{ currentSite.exchangeFeeText }}
          </q-item-section>
          <q-item-section
            class="col-auto"
            :class="isDrawer ? undefined : 'q-pr-sm'"
          >
            <i18n-n
              class="text-bold"
              tag="span"
              :value="order.exchangeFeeTotal"
              format="currency"
              scope="global"
            />
          </q-item-section>
        </q-item>
        <q-item
          v-if="displayTotals && !isDrawer"
          class="bg-responsive-grey-3"
        >
          <q-item-section
            avatar
            style="max-width: 44px; min-width: 44px;"
          >
            <q-avatar
              :icon="currentCircuit.iso31661 === 'GB' ? 'fal fa-circle-sterling' : 'fal fa-circle-dollar'"
              text-color="responsive"
            />
          </q-item-section>

          <q-item-section
            :class="$q.screen.gt.xs ? 'text-h6' : 'text-weight-bolder text-body1'"
            style="font-size: 16px;"
          >
            {{ $t('pricing.pricing') }}
          </q-item-section>
        </q-item>
        <template v-if="$register && !viewOnly && order.user && order.user.currentSiteItemPreferences && order.user.currentSiteItemPreferences.length && registerType && registerType.showFavoritesSection">
          <q-item
            class="q-px-sm justify-apart"
            dense
          >
            <q-item-section class="col text-uppercase text-grey-7 text-bold">
              {{ order.user.firstName }}'s Favorites
            </q-item-section>
          </q-item>

          <q-item
            class="q-py-none justify-evenly"
            dense
          >
            <q-item-section>
              <div class="row justify-center items-start q-gutter-xs q-py-xs">
                <q-btn
                  color="primary"
                  size="sm"
                  dense
                  @click="showFavoritesDialog()"
                >
                  {{ $t('user.actions.seeAllFavorites') }}
                </q-btn>
                <q-btn
                  v-if="order.user.usualOrder"
                  class="col-auto"
                  :color="order.usualOrderAdded ? 'negative' : 'positive'"
                  size="sm"
                  dense
                  @click="order.toggleUsualOrder(order.user.usualOrder); order.usualOrderAdded ? $trackEvent('Added Usual Order') : $trackEvent('Removed Usual Order')"
                >
                  Usual Order
                </q-btn>
                <q-btn
                  v-for="favoriteItem in order.user.currentSiteItemPreferences.slice(0, 6)"
                  :key="favoriteItem.key"
                  class="col-auto"
                  :outline="favoriteItem.frequency < 0.2"
                  color="secondary"
                  size="sm"
                  dense
                  @click="order.addFavorite(favoriteItem); $trackEvent($customerEvents.ADDED_FAVORITE)"
                >
                  {{ favoriteItem.label }} - {{ Math.round(favoriteItem.frequency * 100) }}%
                </q-btn>
              </div>
            </q-item-section>
          </q-item>
          <category-dialog
            v-if="!viewOnly"
            ref="categoryDialog"
            :order="order"
            @request-authorization="callback => $emit('request-authorization', callback)"
          />
        </template>
        <q-item
          v-if="$register && order.comments"
          class="q-px-sm"
          dense
        >
          <q-item-section
            class="col text-uppercase text-grey-7 text-bold"
          >
            {{ $tc('order.comment', 2) }}
          </q-item-section>
          <q-item-section class="col-auto text-subtitle2 text-dark">
            {{ order.comments }}
          </q-item-section>
        </q-item>
        <q-item
          v-if="displayTotals && order.displaySubtotal !== order.total"
          class="row q-pt-sm no-border"
          dense
        >
          <q-item-section>
            <q-item-label>
              {{ $t('pricing.subtotal') }}
            </q-item-label>
          </q-item-section>
          <q-item-section side>
            <i18n-n
              class="text-bold"
              tag="span"
              :value="order.displaySubtotal"
              format="currency"
              scope="global"
            />
          </q-item-section>
        </q-item>
        <booking-fees
          v-if="!hideOrder"
          :booking-fees="cartFormattedOrderItems.bookingFees"
        />
        <template v-if="!order.purchasingMembership && (order.appliedVouchers.length || order.appliedDiscounts.length) && displayTotals">
          <q-item
            dense
            class="no-border"
          >
            <q-item-section>
              <q-item-label
                class="text-red"
              >
                {{ $t('pricing.savings') }}
                <q-badge
                  transparent
                  dense
                  align="middle"
                  color="red"
                  @click="appliedVouchers = true"
                >
                  {{ order.uniqueAppliedVouchers.length + order.appliedDiscounts.length }}  Applied
                </q-badge>
              </q-item-label>
              <q-dialog
                v-model="appliedVouchers"
                :position="$q.screen.lt.sm ? 'right' : undefined"
                :class="$q.screen.lt.sm ? 'bg-responsive' : undefined"
                :maximized="$q.screen.lt.sm && !$register"
                style="min-width: 300px"
              >
                <q-card
                  class="no-shadow"
                  :class="$q.screen.lt.sm ? 'q-px-sm' : undefined"
                  style="min-width: 300px"
                >
                  <q-card-section
                    class="row items-center q-pb-sm"
                  >
                    <template v-if="$q.screen.lt.sm">
                      <q-btn
                        v-close-popup
                        icon="chevron_left"
                        flat
                        round
                        dense
                      />
                    </template>
                    <div class="text-h6">
                      Applied Saving{{ order.uniqueAppliedVouchers.length + order.appliedDiscounts.length > 1 ? 's' : '' }}
                    </div>
                    <template v-if="$q.screen.gt.xs">
                      <q-space />
                      <q-btn
                        v-close-popup
                        icon="close"
                        flat
                        round
                        dense
                      />
                    </template>
                  </q-card-section>
                  <q-list
                    bordered
                    separator
                  >
                    <q-item v-if="order.appliedVouchers.length || !viewOnly">
                      <q-item-section>
                        <q-item-label>
                          {{ $tc('voucher.voucher', 1) }}
                        </q-item-label>
                        <q-item-label>
                          <q-chip
                            v-for="voucher in order.uniqueAppliedVouchers"
                            :key="voucher.typeName + voucher.id"
                            square
                            :removable="!viewOnly && voucher.canRemove"
                            dense
                            :color="voucher.color"
                            text-color="white"
                            :label="(voucher.typeName === 'Voucher' ? voucher.voucherType.name : voucher.name) + ( voucher.isReward ? ` (${voucher.voucherType.pointsCost})` : '')"
                            size="md"
                            class="col"
                            @remove="voucher.autoApply = false; order.applyRedemptions()"
                          />
                        </q-item-label>
                      </q-item-section>
                      <q-item-section
                        top
                        side
                      >
                        <div class="text-subtitle2 col-auto text-red">
                          -
                          <i18n-n
                            class="text-bold text-red"
                            tag="span"
                            :value="order.appliedVoucherAmount"
                            format="currency"
                            scope="global"
                            data-test-id="cart-voucher-applied-value"
                          />
                        </div>
                      </q-item-section>
                    </q-item>
                    <q-item v-if="order.appliedDiscounts.length">
                      <q-item-section>
                        <q-item-label>
                          {{ $tc('pricing.discount', 1) }}
                        </q-item-label>
                        <q-item-label>
                          <q-chip
                            v-for="discount in order.appliedDiscounts"
                            :key="discount.typeName + discount.id"
                            square
                            :removable="!viewOnly && discount.independent"
                            dense
                            :color="discount.color"
                            text-color="white"
                            :label="discount.label"
                            size="md"
                            @remove="order.independentDiscounts.remove(discount); order.applyRedemptions()"
                          />
                        </q-item-label>
                      </q-item-section>
                      <q-item-section
                        side
                        top
                      >
                        <div class="text-subtitle2 col-auto text-red">
                          -
                          <i18n-n
                            class="text-bold text-red"
                            tag="span"
                            :value="order.appliedDiscountAmount"
                            format="currency"
                            scope="global"
                            data-test-id="cart-voucher-applied-value"
                          />
                        </div>
                      </q-item-section>
                    </q-item>
                  </q-list>
                </q-card>
              </q-dialog>
            </q-item-section>
            <q-item-section
              side
            >
              <div
                class="col-auto text-red"
              >
                -
                <i18n-n
                  class="text-red"
                  :class="$register ? 'text-bold' : undefined"
                  tag="span"
                  :value="order.appliedVoucherAmount + order.appliedDiscountAmount"
                  format="currency"
                  scope="global"
                  data-test-id="cart-voucher-applied-value"
                />
              </div>
            </q-item-section>
          </q-item>
        </template>
        <template v-if="order.numberOfGiftCards && displayTotals">
          <q-item
            dense
            class="no-border"
          >
            <q-item-section>
              <q-item-label
                class="text-accent"
              >
                {{ $tc('giftCard.giftCard', 1) }}
                <q-badge
                  transparent
                  dense
                  align="middle"
                  color="accent"
                  @click="showGiftCardsDialog = true"
                >
                  {{ order.numberOfGiftCards }}  Added
                </q-badge>
              </q-item-label>
              <q-dialog
                v-model="showGiftCardsDialog"
                :position="$q.screen.lt.sm ? 'right' : undefined"
                :class="$q.screen.lt.sm ? 'bg-responsive' : undefined"
                :maximized="$q.screen.lt.sm && !$register"
                style="min-width: 300px"
              >
                <q-card
                  class="no-shadow"
                  :class="$q.screen.lt.sm ? 'q-px-sm' : undefined"
                  style="min-width: 300px"
                >
                  <q-card-section
                    class="row items-center q-pb-sm"
                  >
                    <template v-if="$q.screen.lt.sm">
                      <q-btn
                        v-close-popup
                        icon="chevron_left"
                        flat
                        round
                        dense
                      />
                    </template>
                    <div class="text-h6">
                      {{ $tc('giftCard.giftCard', order.numberOfGiftCards) }}
                    </div>
                    <template v-if="$q.screen.gt.xs">
                      <q-space />
                      <q-btn
                        v-close-popup
                        icon="close"
                        flat
                        round
                        dense
                      />
                    </template>
                  </q-card-section>
                  <q-list
                    bordered
                    separator
                  >
                    <q-item v-if="order.numberOfGiftCards">
                      <q-item-section>
                        <q-item-label>
                          <q-chip
                            v-for="giftCard in order.giftCards.data"
                            :key="giftCard.uid + giftCard.id"
                            square
                            dense
                            color="accent"
                            text-color="white"
                            size="md"
                            class="col"
                            :label="giftCard.uid"
                          />
                        </q-item-label>
                      </q-item-section>
                      <q-item-section
                        top
                        side
                      >
                        <div class="text-subtitle2 col-auto text-red">
                          <i18n-n
                            class="text-bold text-accent"
                            tag="span"
                            :value="order.totalGiftCardBalance"
                            format="currency"
                            scope="global"
                            data-test-id="cart-voucher-applied-value"
                          />
                        </div>
                      </q-item-section>
                    </q-item>
                  </q-list>
                </q-card>
              </q-dialog>
            </q-item-section>

            <q-item-section
              side
            >
              <div
                class="text-subtitle2 col-auto text-accent"
              >
                <i18n-n
                  class="text-accent"
                  :class="$register ? 'text-bold' : undefined"
                  tag="span"
                  :value="order.totalGiftCardBalance"
                  format="currency"
                  scope="global"
                  data-test-id="gift-card-value"
                />
              </div>
            </q-item-section>
          </q-item>
        </template>
        <q-item
          v-if="displayTotals && order.taxAmount"
          dense
          class="row no-border"
        >
          <q-item-section>
            <q-item-label>
              {{ $t('pricing.tax') }}
            </q-item-label>
          </q-item-section>
          <q-item-section side>
            <i18n-n
              class="text-bold"
              tag="span"
              :value="order.taxAmount"
              format="currency"
              scope="global"
            />
          </q-item-section>
        </q-item>
        <q-item
          v-if="displayTotals && order.tip"
          dense
          class="row no-border"
        >
          <q-item-section>
            <q-item-label>
              {{ $tc('pricing.tip', 1) }}
            </q-item-label>
          </q-item-section>
          <q-item-section side>
            <i18n-n
              class="text-bold"
              tag="span"
              :value="order.tip"
              format="currency"
              scope="global"
            />
          </q-item-section>
        </q-item>
        <q-item
          v-if="(displayTotal || displayTotals)"
          class="row"
          :class="isDrawer ? 'no-border' : undefined"
        >
          <q-item-section
            class="col-grow"
          >
            <q-item-label
              :overline="!isDrawer"
              class="text-weight-bolder"
              :class="isDrawer ? undefined : 'text-uppercase'"
            >
              {{ $t('pricing.total') }}
            </q-item-label>
          </q-item-section>
          <q-item-section class="text-right">
            <i18n-n
              class="text-bold"
              tag="span"
              :value="order.total"
              format="currency"
              scope="global"
            />
          </q-item-section>
        </q-item>
        <checkout-code-input
          v-if="!hideVoucher && !$register && isCartPage"
          :view-only="viewOnly"
          :is-drawer="isDrawer"
          @add-checkout-code="code => $emit('add-checkout-code', code)"
        />
      </q-list>
    </div>
    <email-dialog
      v-if="!viewOnly && !hideEmailDialog"
      ref="emailDialog"
      :include-delivery-date="includeDeliveryDate"
      @submit="details => saveOrderItemEmail(details)"
    />
    <select-user-form
      v-if="$register && !viewOnly"
      ref="selectUserForm"
      @close-without-assigning-user="orderItem => associateCard(orderItem)"
    />
    <action-dialog
      v-if="!viewOnly"
      ref="assignVoucherDialog"
      title="How do you want to assign this voucher?"
      ok-label="Assign to user"
      cancel-label="Assign to card"
      @ok="assignVoucherToUser"
      @cancel="assignVoucherToCard"
    />
  </component>
</template>

<script>

import { date } from 'quasar'
const { formatDate, addToDate } = date

import { region } from 'src/config'
import Card from 'src/models/card/Card'
import Order from 'src/models/order/Order'
import { ORDER_ITEM_TYPES } from 'src/models/order-item/OrderItem'
import { VOUCHER_TYPE_TYPES } from 'src/models/voucher/VoucherType'
import UnclaimedRefundDialog from 'src/modules/admin/order//UnclaimedRefundDialog'
import RefundDialog from 'src/modules/admin/order/RefundDialog'
import CategoryDialog from 'src/modules/checkout/dialogs/CategoryDialog'
import ActionDialog from 'src/modules/consumer/components/ActionDialog'
import EmailDialog from 'src/modules/consumer/components/EmailDialog'
import CheckoutCodeInput from 'src/modules/register/components/cart/CheckoutCodeInput'
import GuestTicketsItem from 'src/modules/register/components/cart/GuestTicketsItem'
import ItemsItem from 'src/modules/register/components/cart/ItemsItem'
import MemberTicketsItem from 'src/modules/register/components/cart/MemberTicketsItem'
import Price from 'src/modules/register/components/cart/Price'
import Redemptions from 'src/modules/register/components/cart/Redemptions'
import OrderItemForm from 'src/modules/register/components/order-item-form/OrderItemForm'
import SelectUserForm from 'src/modules/register/components/SelectUserForm'
import IncomingEmployeeSelectDialog from 'src/modules/register/dialogs/IncomingEmployeeSelectDialog'
import OrderOptionsDialog from 'src/modules/register/dialogs/OrderOptionsDialog'
import { defineAsyncComponent } from 'vue'
const sortAlphaNum = (a, b) => a.localeCompare(b, 'en', { numeric: true })

export default {
  name: 'Cart',
  components: {
    OrderItemForm,
    OrderOptionsDialog,
    RefundDialog,
    CategoryDialog,
    EmailDialog,
    SelectUserForm,
    ActionDialog,
    UnclaimedRefundDialog,
    MemberTicketsItem,
    GuestTicketsItem,
    ItemsItem,
    Redemptions,
    Price,
    CheckoutCodeInput,
    IncomingEmployeeSelectDialog,
    BookingFees: defineAsyncComponent(() => import('src/modules/register/components/cart/BookingFees.vue'))
  },
  configuration: ['currentSite', 'currentCircuit'],
  context: ['currentUser', 'currentRegisterClient'],
  inject: ['order', 'checkoutData'],
  props: {
    page: {
      type: Boolean,
      required: false,
      default: false
    },
    viewOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    displayTotal: {
      type: Boolean,
      required: false,
      default: false
    },
    displayTotals: {
      type: Boolean,
      required: false,
      default: false
    },
    isDrawer: {
      type: Boolean,
      required: false,
      default: false
    },
    hideOrder: {
      type: Boolean,
      required: false,
      default: false
    },
    hideDelivery: {
      type: Boolean,
      required: false,
      default: false
    },
    hideRedemptions: {
      type: Boolean,
      required: false,
      default: false
    },
    hideVoucher: {
      type: Boolean,
      required: false,
      default: false
    },
    isCartPage: {
      type: Boolean,
      required: false,
      default: false
    },
    hideEmailDialog: {
      type: Boolean,
      required: false,
      default: false
    },
    showBookingFees: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['modify-membership', 'place-order', 'add-checkout-code', 'request-authorization', 'find-user', 'merge-tab', 'refund-success', 'show-seats-dialog', 'remove-user', 'login', 'register', 'input-checkout-code'],
  data () {
    return {
      showOrderOptions: false,
      selectedOrderItem: null,
      reformatCartOrderItems: false,
      touchHoldId: null,
      pendingVoucherOrderItem: null,
      deliveryMessage: null,
      redemptions: false,
      appliedVouchers: false,
      includeDeliveryDate: false,
      showGiftCardsDialog: false,
      expandDefault: false,
      expandTickets: false,
      expandConcessions: false
    }
  },
  computed: {
    numberOfActivityTicketsAndDayPass () {
      return _.sum([this.order.activityTicketOrderItems.length, this.order.dayPassOrderItems.length])
    },
    activityTicketsAndDayPassTotal () {
      return _.sum([this.order.activityTicketOrderItemsTotal, this.order.dayPassOrderItemsTotal])
    },
    isCartPageInLandscapeView () {
      return this.$isLandscapeView() && this.isCartPage
    },
    cartOrderItems () {
      return this.order.orderItems?.data || []
    },
    registerType () {
      return this.currentRegisterClient?.registerStation?.registerType
    },
    showGroupTicketPrinting () {
      return this.registerType?.groupTicketPrintingEnabled && this.order.hasMultipleTicketsForShowing
    },
    showRedemptionsOnRegister () {
      return (this.order.unappliedVouchers.length || this.order.availableDiscounts.length || this.order.availableRewards.length || (this.order.user && (this.order.unavailableRewards.length || this.order.totalPoints)))
    },
    cartFormattedOrderItems () {
      const cartOrderItems = this.order.orderItems?.data || []

      if (!cartOrderItems) {
        return {}
      }

      if (this.reformatCartOrderItems) {
        // Do nothing - reformatCartOrderItems is used to instruct Vue that this property needs to be recomputed
      }

      const results = {}
      // Group things they way we will display them in the shopping cart

      // Tickets grouped by showing
      /*
        {
          tickets: [
            showing: { movie, ... }
            memberTickets: [{
              user,
              price
            }],
            guestTicketsByClassAndCount: [{
              userType,
              count,
              price,
              total
            }]
          ]
        }
        */
      results.tickets = _(cartOrderItems)
        .filter({ type: 'ticket' })
        .groupBy('ticket.showing.id')
        .values()
        .sortBy((orderItems) => _(cartOrderItems).map('id').indexOf(orderItems[0].id)) // Sort by original order
        .map((orderItems) => {
          const memberTickets = _.filter(orderItems, (orderItem) => orderItem.ticket.user && orderItem.ticket.user)
          const guestTickets = _(orderItems).filter((orderItem) => (!orderItem.ticket.user || !orderItem.ticket.user)).groupBy('ticketEquivalencyString').values().map((orderItems) => {
            const ticketType = orderItems[0].ticket.ticketType
            const count = orderItems.length

            const displayPrice = _.sum(_.map(orderItems, 'displayPrice'))
            const displayRedemptionTotal = _.sum(_.map(orderItems, 'displayRedemptionTotal'))
            const displayTotal = _.sum(_.map(orderItems, 'displayTotal'))
            const seatNames = _(orderItems).map('ticket.seatName').compact().value().sort(sortAlphaNum).join(', ')

            const showing = orderItems[0].ticket.showing
            const needsSeatSelection = showing.reservedSeating && !_.every(_.map(orderItems, 'ticket.seatName'))

            return {
              orderItems,
              firstOrderItem: orderItems[0],
              lastOrderItem: orderItems[orderItems.length - 1],
              ticketType,
              showing,
              count,
              needsSeatSelection,
              individualPrice: orderItems[0].displayPrice,
              displayPrice,
              displayTotal,
              displayRedemptionTotal,
              seatNames
            }
          }).value()

          const count = orderItems.length
          const displayTotal = _(orderItems).map(orderItem => {
            if (orderItem.includeBookingFeeInPrice) {
              return orderItem.displayTotal
            } else if (this.currentSite.consumerConfig.showBookingFeeInCart) {
              return orderItem.displayTotal + orderItem.bookingFeeDisplayPrice
            }
          }).sum()
          const showing = orderItems[0].ticket.showing

          return {
            showing,
            memberTickets,
            guestTickets,
            orderItems,
            count,
            displayTotal
          }
        }).value()

      results.bookingFees = _(cartOrderItems)
        .filter(orderItem => orderItem.type === 'booking-fee' || (orderItem.type === 'ticket' && !!orderItem.localBookingFeeType))
        .groupBy(orderItem => orderItem.localBookingFeeType?.name || orderItem.description)
        .values()
        .sortBy((orderItems) => (_.first(orderItems).bookingFeeType || _.first(orderItems).localBookingFeeType)?.priorityOrder)
        .map((orderItems) => {
          const bookingFeeType = _.first(orderItems).localBookingFeeType || _.first(orderItems).bookingFeeType
          const bookingFeeName = bookingFeeType?.name || _.first(orderItems).description
          const displayPrice = _(orderItems).map(orderItem => {
            let bookingFeePrice = 0

            if (orderItem.type === 'ticket' && (orderItem.setAsGross && !this.displayTotals)) {
              bookingFeePrice = orderItem.bookingFeeTotal
            } else if (orderItem.type === 'ticket') {
              bookingFeePrice = orderItem.bookingFeeAmount
            } else if (orderItem.type === 'booking-fee' && !this.displayTotals) {
              bookingFeePrice = orderItem.displayPrice
            } else if (orderItem.type === 'booking-fee') {
              bookingFeePrice = orderItem.subtotal
            }

            return bookingFeePrice
          }).sum()
          const count = orderItems.length

          return {
            id: bookingFeeType?.id,
            name: bookingFeeName,
            orderItems,
            count,
            displayPrice
          }
        }).value()

      results.activityTickets = _(cartOrderItems)
        .filter({ type: 'activity-ticket' })
        .groupBy('activityTicket.activitySession.id')
        .values()
        .sortBy((orderItems) => _(cartOrderItems).map('id').indexOf(orderItems[0].id)) // Sort by original order
        .map((orderItems) => {
          const memberTickets = _.filter(orderItems, (orderItem) => !!orderItem.activityTicket.user)
          const guestTickets = _(orderItems).filter((orderItem) => !orderItem.activityTicket.user).groupBy('activityTicketEquivalencyString').values().map((orderItems) => {
            const ticketType = orderItems[0].activityTicket.ticketType
            const count = orderItems.length

            const displayPrice = _.sum(_.map(orderItems, 'displayPrice'))
            const displayRedemptionTotal = _.sum(_.map(orderItems, 'displayRedemptionTotal'))
            const displayTotal = _.sum(_.map(orderItems, 'displayTotal'))
            const activitySession = orderItems[0].activityTicket.activitySession

            return {
              orderItems,
              firstOrderItem: orderItems[0],
              lastOrderItem: orderItems[orderItems.length - 1],
              ticketType,
              activitySession,
              count,
              individualPrice: orderItems[0].displayPrice,
              displayPrice,
              displayTotal,
              displayRedemptionTotal
            }
          }).value()

          const count = orderItems.length
          const displayTotal = _.sum(_.map(orderItems, 'displayTotal'))
          const activitySession = orderItems[0].activityTicket.activitySession

          return {
            activitySession,
            memberTickets,
            guestTickets,
            orderItems,
            count,
            displayTotal
          }
        }).value()

      // Concession Items grouped by exact match. Supports expansion.
      results.items = _(cartOrderItems).filter({ type: 'item' }).groupBy('itemEquivalencyString').values().map((orderItems) => {
        const count = orderItems.length
        const displayPrice = _.sum(_.map(orderItems, 'displayPrice'))
        const displayRedemptionTotal = _.sum(_.map(orderItems, 'displayRedemptionTotal'))
        const displayTotal = _.sum(_.map(orderItems, 'displayTotal'))

        return {
          firstOrderItem: orderItems[0],
          lastOrderItem: orderItems[orderItems.length - 1],
          orderItems,
          count,
          displayPrice,
          displayRedemptionTotal,
          displayTotal
        }
      }).value()

      // Membership intervals
      results.membershipIntervals = _(cartOrderItems).filter({ type: 'membership-interval' }).value()

      results.dayPass = _.find(cartOrderItems, { type: 'day-pass' })

      // Vouchers
      results.vouchers = _(cartOrderItems)
        .filter(orderItem => orderItem.group && (orderItem.type === 'voucher-purchase' || orderItem.type === 'voucher-service-issue'))
        .groupBy('voucherEquivalencyString')
        .values()
        .concat(
          _(cartOrderItems)
            .filter(orderItem => !orderItem.group && (orderItem.type === 'voucher-purchase' || orderItem.type === 'voucher-service-issue'))
            .map(orderItem => [orderItem]).value())
        .sortBy((orderItems) => _(cartOrderItems).map('id').indexOf(orderItems[0].id)) // Sort by original order
        .map((orderItems) => {
          const voucherType = orderItems[0].voucherPurchase.voucherType
          const count = orderItems.length

          const displayPrice = _.sum(_.map(orderItems, 'displayPrice'))
          const displayRedemptionTotal = _.sum(_.map(orderItems, 'displayRedemptionTotal'))
          const displayTotal = _.sum(_.map(orderItems, 'displayTotal'))

          return {
            orderItems,
            firstOrderItem: orderItems[0],
            lastOrderItem: orderItems[orderItems.length - 1],
            voucherType,
            count,
            individualPrice: orderItems[0].displayPrice,
            displayPrice,
            displayTotal,
            displayRedemptionTotal
          }
        }).value()

      // Gift Cards
      results.giftCards = _(cartOrderItems)
        .filter(orderItem => orderItem.group && orderItem.type === 'gift-card')
        .groupBy('giftCardEquivalencyString')
        .values()
        .concat(
          _(cartOrderItems)
            .filter(orderItem => !orderItem.group && orderItem.type === 'gift-card')
            .map(orderItem => [orderItem]).value())
        .sortBy((orderItems) => _(cartOrderItems).map('id').indexOf(orderItems[0].id)) // Sort by original order
        .map((orderItems) => {
          const count = orderItems.length
          const displayPrice = _.sum(_.map(orderItems, 'displayPrice'))
          const displayRedemptionTotal = _.sum(_.map(orderItems, 'displayRedemptionTotal'))
          const displayTotal = _.sum(_.map(orderItems, 'displayTotal'))

          return {
            orderItems,
            firstOrderItem: orderItems[0],
            lastOrderItem: orderItems[orderItems.length - 1],
            count,
            individualPrice: orderItems[0].displayPrice,
            displayPrice,
            displayTotal,
            displayRedemptionTotal
          }
        }).value()

      results.voucherPackages = _.filter(cartOrderItems, orderItem => orderItem.type === 'voucher-package-purchase')

      // Misc Items
      results.miscItems = _.filter(cartOrderItems, orderItem => _.includes(['misc-item', 'user-credit', 'donation', 'tip'], orderItem.type))

      return results
    }
  },
  watch: {
    // TODO INDY-1592 Fix infinite loop in this watcher after redeeming points
    // async cartFormattedOrderItems () {
    //   await this.$nextTick()

    //   const mostRecentlyAdded = _.minBy(this.order.orderItems.data, 'id')

    //   if (!mostRecentlyAdded) return

    //   const mostRecentlyAddedEl = this.$refs['cartItem' + mostRecentlyAdded.id]

    //   if (!mostRecentlyAddedEl) return

    //   mostRecentlyAddedEl[0]?.$el?.scrollIntoView({ behavior: 'smooth', alignToTop: false })
    // },
    'checkoutData.expandDefault': {
      handler () {
        if (this.checkoutData?.expandDefault) {
          this.expandDefault = true
        } else {
          this.expandDefault = false
        }
      },
      immediate: true
    },
    'checkoutData.expandTickets': {
      handler () {
        if (this.checkoutData?.expandTickets) {
          this.expandTickets = true
        } else {
          this.expandTickets = false
        }
      },
      immediate: true
    },
    'checkoutData.expandConcessions': {
      handler () {
        if (this.checkoutData?.expandConcessions) {
          this.expandConcessions = true
        } else {
          this.expandConcessions = false
        }
      },
      immediate: true
    }
  },
  created () {
    _.extend(this, { formatDate, addToDate, region })
    if (!this.viewOnly) this.setupPrintMonitoring()
  },
  mounted () {
    if (!this.viewOnly && this.$consumer) {
      const anyOrderItemsRequireEmail = _.find(this.order.orderItems.data, orderItem => _.includes(ORDER_ITEM_TYPES.REQUIRES_EMAIL, orderItem.type) && !this.findDetail(orderItem.details, 'recipient_email'))

      if (anyOrderItemsRequireEmail) {
        const anyOrderItemsRequireDeliveryDate = _.find(this.order.orderItems.data, orderItem => _.includes(ORDER_ITEM_TYPES.GIFT_CARD, orderItem.type))
        if (anyOrderItemsRequireDeliveryDate) {
          this.includeDeliveryDate = true
        }
        this.$refs.emailDialog.show()
      }
    }
    this.processQueryParameters()
  },
  unmounted () {
    this.orderForPrintMonitoring?.destroy()
    clearTimeout(this.monitorPrintingId)

    this.isDestroyed = true
  },
  methods: {
    async triggerShowOrderOptions () {
      this.showOrderOptions = false
      await this.$nextTick()
      this.showOrderOptions = true
    },
    handleTicketTouchHold (value, showing, ticketType, itemPackage) {
      if (!value) {
        this.touchHoldId = null
      } else {
        this.touchHold(() => { this.addGuestTicket(showing, ticketType, itemPackage) })
      }
    },
    handleItemTouchHold (value, item) {
      if (!value) {
        this.touchHoldId = null
      } else {
        this.touchHold(() => { this.addOrderItem(item) })
      }
    },
    async touchHold (callback) {
      if (!this.$register) return
      const actionIdentifier = Math.random()
      this.touchHoldId = actionIdentifier
      await new Promise((resolve) => setTimeout(resolve, 500))
      while (this.touchHoldId === actionIdentifier) {
        callback()
        await new Promise((resolve) => setTimeout(resolve, 100))
      }
    },
    addGuestTicket (showing, ticketType, itemPackage = null) {
      if (this.$register && !this.currentUser.admin && ticketType.requiresAuthorization) {
        if (this.touchHoldId) return
        this.$emit('request-authorization', () => this.order.addGuestTicket(showing, ticketType, itemPackage))
      } else {
        this.order.addGuestTicket(showing, ticketType, itemPackage)
      }
    },
    edit (orderItem) {
      if (orderItem.state !== 'draft') return

      if (orderItem.itemPackage && !this.$register) return

      if (orderItem.type === 'ticket' && orderItem.ticket.showing.reservedSeating && this.$consumer) {
        this.$order.currentShowing = orderItem.ticket.showing
        this.$router.push(`/checkout/seats/${orderItem.ticket.showing.id}?ticketId=${orderItem.ticket.id}`)
      } else if (orderItem.type === 'ticket' && orderItem.ticket.showing.reservedSeating && (this.$station)) {
        this.$emit('show-seats-dialog', this.order, orderItem.ticket.showing, orderItem.ticket)
      } else if (orderItem.type === 'item') {
        this.$refs.form.setCollection(this.order.orderItems)
        this.$refs.form.show(orderItem)
      } else if (orderItem.type === 'voucher-purchase' || orderItem.type === 'voucher-service-issue' || orderItem.type === 'gift-card' || orderItem.type === 'voucher-package-purchase') {
        if (!this.$register) {
          if (orderItem.group) {
            orderItem.group = false
            this.reformatCartOrderItems = !this.reformatCartOrderItems
          }
          return
        }

        if (orderItem.type === 'voucher-purchase' || orderItem.type === 'voucher-package-purchase' || orderItem.type === 'voucher-service-issue') {
          this.pendingVoucherOrderItem = orderItem
          this.$refs.assignVoucherDialog.show()
        } else {
          this.associateCard(orderItem)
        }
      }
    },
    async assignVoucherToUser () {
      this.$refs.selectUserForm.show(this.pendingVoucherOrderItem)
    },
    assignVoucherToCard () {
      this.associateCard(this.pendingVoucherOrderItem)
    },
    associateCard (orderItem) {
      this.$cardHandler.requestBlankCardScan(
        orderItem.voucherPurchase?.voucherType?.name || orderItem.issuedVoucherPackage?.voucherPackage?.name || 'Gift Card',
        _.flatten(_.map(orderItem.order.orderItems.data, 'cardUids')),
        (uid) => {
          let cardable
          if (orderItem.type === 'voucher-purchase' || orderItem.type === 'voucher-service-issue') {
            cardable = orderItem.voucherPurchase
          } else if (orderItem.type === 'gift-card') {
            cardable = orderItem.giftCard
          } else if (orderItem.type === 'voucher-package-purchase') {
            cardable = orderItem.issuedVoucherPackage
          } else {
            throw new Error('Unhandled order item type in card assignment: ' + orderItem.type)
          }

          if (uid === false) {
            cardable.skipCard = true
            cardable.card = null
            return
          }

          if (!uid) return

          if (!cardable.validateCardUid(uid)) {
            this.$mh.error('Card does not match item barcode rules')
            this.associateCard(orderItem)
            return
          }

          cardable.skipCard = false
          cardable.card = new Card({ uid })
        }
      )
    },
    associateCardWithItem (item, orderItem, name = null) {
      this.$cardHandler.requestBlankCardScan(
        name || item.voucherPackage?.name || item.voucherType?.name || 'Gift Card',
        _.flatten(_.map(orderItem.order.orderItems.data, 'cardUids')),
        (uid) => {
          let cardable
          if (item.typeName === 'Voucher' || item.typeName === 'GiftCard' || item.typeName === 'IssuedVoucherPackage') {
            cardable = item
          } else {
            throw new Error('Unhandled order item type in card assignment: ' + item.typeName)
          }

          if (uid === false) {
            cardable.skipCard = true
            cardable.card = null
            return
          }

          if (!uid) return

          if (!cardable.validateCardUid(uid)) {
            this.$mh.error('Card does not match item barcode rules')
            this.associateCardWithItem(item, orderItem, name)
            return
          }

          cardable.skipCard = false
          cardable.card = new Card({ uid })
        }
      )
    },
    applyVoucher (vouchers) {
      if (vouchers.firstVoucher.autoApply && vouchers.firstVoucher.autoCreate) {
        this.order.applyVoucher(vouchers.firstVoucher)
      } else {
        vouchers.firstVoucher.autoApply = true
        vouchers.firstVoucher.autoCreate = true

        this.order.applyRedemptions()
      }
    },
    removeVoucher (items) {
      if (items.firstOrderItem.localVoucher.isUnlimited) {
        items.firstOrderItem.localVoucher.autoApply = false
      }

      items.firstOrderItem.skipVoucher = true
      this.order.applyRedemptions()
    },
    applyDiscount (discount) {
      this.order.applyDiscount(discount)
    },
    removeOrderItem (orderItem) {
      if (orderItem.localVoucher?.voucherType?.type === VOUCHER_TYPE_TYPES.SPECIFIC_ITEM || orderItem.localVoucher?.voucherType?.type === VOUCHER_TYPE_TYPES.ITEM_PACKAGE) {
        orderItem.localVoucher.autoApply = false
      }
      this.order.removeOrderItem(orderItem)
    },
    addOrderItem (orderItem) {
      if (orderItem.itemPackage) {
        const showing = _.findLast(this.order.orderItems.data, (oi) => oi.itemPackageId === orderItem.itemPackage.id && oi.type === 'ticket')?.ticket?.showing || null
        const userTicketAlreadyAdded = !!(orderItem.user && this.order.findPackageTicketOrderItem(showing, orderItem.itemPackage, orderItem.user))

        this.order.addItemPackage(orderItem.itemPackage, showing, userTicketAlreadyAdded ? null : orderItem.user)
      } else {
        this.order.addCopy(orderItem)
      }
    },
    handleDeleteRequest (orderItems, options) {
      if (orderItems[0].draft && orderItems[0].canRemove !== true) {
        this.$q.dialog({
          title: 'Cannot Remove',
          message: orderItems[0].canRemove
        })
        options.reset && options.reset()
      } else if (orderItems[0].draft) {
        _.each(orderItems, orderItem => {
          this.removeOrderItem(orderItem)
          if (orderItem.isTicket) {
            this.checkoutData.removeSeats.push(orderItem)
          }
        })
      } else if (orderItems[0].placed) {
        const voidOrderItemIds = _.map(orderItems, 'id')

        if (this.currentUser.admin) {
          this.$refs.refundDialog.show(this.order, voidOrderItemIds)
        } else {
          this.$emit('request-authorization', () => { this.$refs.refundDialog.show(this.order, voidOrderItemIds) })
        }
        options.reset && options.reset()
      }
    },
    handleDeleteVouchers (orderItems, options) {
      if (orderItems[0].draft) {
        const cartOrderItems = this.order.orderItems?.data || []
        if (orderItems[0].details.find(detail => detail.minimumAmount)) {
          // These vouchers have a minimum requirement
          // If the number of vouchers to remove would take us beneath the minimum requirement, remove all related vouchers
          const voucherSaleKey = orderItems[0].details.find(detail => detail.key).key
          const vouchers = _(cartOrderItems).filter(orderItem => orderItem.type === 'voucher-purchase' && voucherSaleKey === orderItem.details.find(detail => detail.key).key).value()

          if (vouchers.length !== orderItems.length && vouchers.length - orderItems.length < orderItems[0].details.find(detail => detail.minimumAmount).minimumAmount) {
            this.$q.dialog({
              title: 'Delete Voucher',
              message: 'This voucher is sold with a minimum limit. Do you want to delete this and all associated vouchers?',
              ok: 'Delete All',
              cancel: true
            }).onOk(() => {
              this.handleDeleteRequest(vouchers, options)
            }).onDismiss(() => {
              options.reset()
            })
            return
          }
        }

        _.each(orderItems, orderItem => this.removeOrderItem(orderItem))
      } else if (orderItems[0].placed) {
        const voidOrderItemIds = _.map(orderItems, 'id')

        if (this.currentUser.admin) {
          this.$refs.refundDialog.show(this.order, voidOrderItemIds)
        } else {
          this.$q.dialog({
            title: 'Admin Required',
            message: 'You must be signed in as an Admin to initiate a refund.'
          })
        }
        options.reset && options.reset()
      }
    },
    handleDeleteMembership (orderItem, options) {
      if (orderItem.draft) {
        const draftMemberships = _.filter(this.cartFormattedOrderItems.membershipIntervals, membershipInterval => membershipInterval.draft)
        _.each(draftMemberships, orderItem => this.removeOrderItem(orderItem))
      } else {
        const completedMemberships = _.filter(this.cartFormattedOrderItems.membershipIntervals, membershipInterval => membershipInterval.state !== 'draft')

        const voidOrderItemIds = _.map(completedMemberships, 'id')

        if (this.currentUser.admin) {
          this.$refs.refundDialog.show(this.order, voidOrderItemIds)
        } else {
          this.$q.dialog({
            title: 'Admin Required',
            message: 'You must be signed in as an Admin to initiate a refund.'
          })
        }
        options?.reset?.()
      }
    },
    handleDeleteDayPass (options) {
      if (!this.cartFormattedOrderItems.dayPass) return

      const [tickets = {}] = this.cartFormattedOrderItems.tickets
      const { orderItems: allTickets = [], memberTickets = [] } = tickets

      const orderItems = [
        this.cartFormattedOrderItems.dayPass,
        ...(this.currentSite.membershipRequired ? allTickets : memberTickets)
      ]

      if (this.cartFormattedOrderItems.dayPass.draft) {
        _.each(orderItems, orderItem => this.removeOrderItem(orderItem))
        this.$emit('remove-user')
      } else {
        const voidOrderItemIds = _.map(orderItems, 'id')

        if (this.currentUser.admin) {
          this.$refs.refundDialog.show(this.order, voidOrderItemIds)
        } else {
          this.$q.dialog({
            title: 'Admin Required',
            message: 'You must be signed in as an Admin to initiate a refund.'
          })
        }
        options?.reset?.()
      }
    },
    removeIcon (orderItems) {
      const orderItem = orderItems[0]
      if (orderItem.draft) {
        return {
          icon: 'delete',
          color: 'warning',
          label: 'Remove' + (orderItems.length > 1 ? ' All' : '')
        }
      } else if (orderItem.placed && orderItem.pickPrepPrintingStatus === 'success') {
        return {
          icon: 'delete',
          color: 'negative',
          label: 'Void' + (orderItems.length > 1 ? ' All' : '')
        }
      } else if (orderItem.placed) {
        return {
          icon: 'delete',
          color: 'negative',
          label: 'Void' + (orderItems.length > 1 ? ' All' : '')
        }
      } else {
        return {}
      }
    },
    setupPrintMonitoring () {
      if (!this.$register) return

      this.orderForPrintMonitoring = new Order({
        id: this.order.id
      }, {
        fields: ['id'],
        orderItems: {
          fields: ['id', 'pickPrepPrintingStatus']
        }
      })
      this.monitorPrintingForOrder()
    },
    monitorPrintingForOrder () {
      if (this.monitorPrintingId) clearTimeout(this.monitorPrintingId)

      this.monitorPrintingId = setTimeout(async () => {
        if (this.isDestroyed) return

        if (this.shouldCheckPrintingStatus()) {
          this.orderForPrintMonitoring.id = this.order.id
          await this.orderForPrintMonitoring.fetch(true)
          _.each(this.orderForPrintMonitoring.orderItems.data, orderItem => {
            const matchingOrderItem = _.find(this.order.orderItems.data, { id: orderItem.id })
            if (matchingOrderItem) matchingOrderItem.pickPrepPrintingStatus = orderItem.pickPrepPrintingStatus
          })
        }
        this.monitorPrintingForOrder()
      }, 500)
    },
    shouldCheckPrintingStatus () {
      if (this.order.isLocal) return false

      if (!this.order.waitingForPreparationPrinting) return false

      return true
    },
    showFavoritesDialog () {
      this.$refs.categoryDialog.show(this.order.user.itemPreferencesAsCategory)
    },
    findDetail (details, detailName) {
      return details.find(detail => detail[detailName])
    },
    updateOrderItemEmail (orderItem) {
      this.selectedOrderItem = orderItem
      if (orderItem.type === ORDER_ITEM_TYPES.GIFT_CARD) this.includeDeliveryDate = true
      this.$refs.emailDialog.show(
        orderItem.details.find(detail => detail.recipient_email).recipient_email,
        orderItem.details.find(detail => detail.message)?.message,
        orderItem.hasDueTime ? orderItem.siteDueTime : undefined
      )
    },
    saveOrderItemEmail (details) {
      if (this.selectedOrderItem) {
        this.selectedOrderItem.details.find(detail => detail.recipient_email).recipient_email = details.email
        this.selectedOrderItem.details.find(detail => detail.send_copy_to_current_user).send_copy_to_current_user = details.sendCopyToCurrentUser
        this.selectedOrderItem.details.find(detail => detail.message).message = details.message

        if (!!details.deliveryDate && this.selectedOrderItem.type === ORDER_ITEM_TYPES.GIFT_CARD) {
          const now = new Date()
          if (this.details.deliveryDate.getTime() > now.getTime()) {
            this.selectedOrderItem.hasDueTime = true
            this.selectedOrderItem.dueTime = details.deliveryDate
          }
        }
      } else {
        const emailOrderItems = _.filter(this.order.orderItems.data, orderItem => _.includes(ORDER_ITEM_TYPES.REQUIRES_EMAIL, orderItem.type))
        _.each(emailOrderItems, orderItem => {
          orderItem.details.push({ recipient_email: details.email, message: details.message, send_copy_to_current_user: details.sendCopyToCurrentUser })
        })

        if (details.deliveryDate) {
          const now = new Date()
          if (details.deliveryDate.getTime() > now.getTime()) {
            const giftCardOrderItems = _.filter(emailOrderItems, orderItem => orderItem.type === ORDER_ITEM_TYPES.GIFT_CARD)
            _.each(giftCardOrderItems, orderItem => {
              orderItem.hasDueTime = true
              orderItem.dueTime = details.deliveryDate
            })
          }
        }
      }
      this.includeDeliveryDate = false
    },
    processQueryParameters () {
      const message = []
      if (this.$route.query['delivery-type']) {
        this.order.deliveryType = this.$route.query['delivery-type']
        message.push(_.startCase(this.order.deliveryTypeName))
      }
      if (this.$route.query['delivery-location']) {
        this.order.deliveryLocation = decodeURIComponent(this.$route.query['delivery-location'])
        message.push(this.order.deliveryLocation)
      } else if (this.$route.query['table-name']) {
        this.order.deliveryLocation = this.$route.query['table-name']
        message.push(this.order.deliveryLocation)
      } else if (this.$route.query['seat-name']) {
        this.order.deliveryLocation = this.$route.query['seat-name'].split(' - ')[0]
        message.push(this.order.deliveryLocation)
        this.order.deliveryPostions = [this.$route.query['seat-name'].split(' - ')[1]]
        message.push(this.order.deliveryPostions)
      }
      if (this.$route.query['delivery-position']) {
        this.order.deliveryPostions = [decodeURIComponent(this.$route.query['delivery-position'])]
        message.push(this.order.deliveryPostions)
      }
      if (this.$route.query['delivery-details']) {
        this.order.deliveryDetails = decodeURIComponent(this.$route.query['delivery-details'])
        message.push(this.order.deliveryDetails)
      }
      if (message.length) {
        this.deliveryMessage = message.join(' - ')
      }
    },
    login () {
      if (this.$kiosk) {
        this.$emit('login')
        return
      } else if (this.$consumer) {
        this.$auth.setPostAuthRoute(this.$route.fullPath)
      }
      this.$router.push('/login')
    },
    register () {
      if (this.$kiosk) {
        this.$emit('register')
        return
      } else if (this.$consumer) {
        this.$auth.setPostAuthRoute(this.$route.fullPath)
      }
      this.$router.push('/register')
    },
    showIncomingEmployeeSelectDialog () {
      this.$refs.IncomingEmployeeSelectDialog.show()
    },
    async requestIncomingEmployee (employee, force) {
      if (force) {
        await this.order.transferTab(employee)
      } else {
        await this.order.requestTabTransfer(employee)
      }
      this.order.fetch(true)
      this.$q.notify({
        message: 'Transfer Request Sent',
        type: 'positive',
        position: 'top'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.q-expansion-item--expanded .expansion-header {
  border-bottom: solid 1px #DFDFDF;
}

.q-btn .q-icon{
    font-size: 1.2em;
    padding: 0 4px;
}
</style>
